import { Button, LinearProgress } from "@material-ui/core";
import Axios from "axios";
import "boxicons";
import Moments from "moment";
import React, { Component } from "react";
import { Alert, Badge, Form, Modal, Row, Table } from "react-bootstrap";
import Moment from "react-moment";
import swal from "sweetalert";
import AppConfig from "../../../../../config/AppConfig";
import { Link } from "react-router-dom";

class KebijakanSPMI extends Component {
  constructor(props, context) {
    super(props, context);
    this.handleChangeAlasan = this.handleChangeAlasan.bind(this);
    this.handleClose = this.handleClose.bind(this);
    // Pengaturan 1
    this.handleEditButtonP1 = this.handleEditButtonP1.bind(this);
    this.handleEditTidakAdaP1 = this.handleEditTidakAdaP1.bind(this);

    this.handleShowP1 = this.handleShowP1.bind(this);
    this.handleOrganisasiP2 = this.handleOrganisasiP2.bind(this);
    this.handleShowP3 = this.handleShowP3.bind(this);
    this.handleShowP4 = this.handleShowP4.bind(this);
    this.handleShowP5 = this.handleShowP5.bind(this);
    this.handleShowP6 = this.handleShowP6.bind(this);

    // USING STATE
    this.state = {
      display: false,
      // data semua pengaturan
      get_pengaturan: [],
      // insert state
      id_ajuan_pengaturan: "",
      id_jenis_aturan: "",
      status: "",
      keterangan: "",
      tautan: "",
      deskripsi: "",
      tanggal_penetapan: "",
      // UPDATE STATE
      statusEdit: "",
      id_ajuan_pengaturanEdit: "",
      tautanEdit: "",
      deskrispiEdit: "",
      id_jenis_aturanEdit: "",
      tanggal_penetapanEdit: "",
      statusajuanEdit: "",
      keteranganEdit: "",
      // State untuk status ada /tidak ada dalam pengaturan
      showAda: false,
      showEdit: false,
      showTidakAda: false,
      showTidakAdaEdit: false,
      p1_status: "",
      p2_status: "",
      p3_status: "",
      p4_status: "",
      p5_status: "",
      p6_status: "",
      //component state
      isRadioSelected: true,
      loading: false,
      loadingBar: true,
      errorMessage: "",
      //HISTORICAL
      showHistorical: false,
      get_jenis: [],
      dataHistorical: [],
      display_datahistorical: false,
    };
  }
  handleClickInterface = (id_jenis_aturan) => {
    let tahun_siklus = localStorage.getItem("tahun_siklus");
    swal({
      title: "Konfirmasi",
      text: "Apakah Anda ingin menyalin pengaturan SPMI ini dari tahun sebelumnya untuk tahun " + tahun_siklus + "?",
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then((willSave) => {
      if (willSave) {
        let userdata = JSON.parse(localStorage.getItem("userdata"));
        let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
        let session = "";
        if (userdata) {
          session =
            "?id_pengguna=" +
            userdata.id_pengguna +
            "&id_unit=" +
            sessiondata.i_idunit +
            "&id_role=" +
            sessiondata.i_idrole;
        }

        this.setState({ loading: true });
        let session_tahun_siklus = localStorage.getItem("tahun_siklus")
        Axios.get(AppConfig.urlDefault + "penetapan/savepengaturancp/" + id_jenis_aturan + "/" + session_tahun_siklus + session)
          .then((res) => {
            this.setState({ loading: false });
            if (res.data.status === "error") {
              swal("Gagal!", res.data.message, {
                icon: "error",
              });
              return
            } else {
              swal("Berhasil!", "Pengaturan telah ditetapkan untuk tahun " + session_tahun_siklus, {
                icon: "success",
              });
            }
            this.componentDidMount();
          })
          .catch((err) => {
            this.setState({ loading: false });
            swal("Gagal!", "Pengaturan gagal ditetapkan untuk tahun " + session_tahun_siklus, {
              icon: "error",
            });
          });
      }
    });
  };
  handleShowHistorical = (event) => {
    this.setState({
      showHistorical: true,
      display_datahistorical: false,
      loading: false,
      get_jenis: event,
    });
    let id_institusi = localStorage.getItem("id_sp_temp");
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    const sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let id_sp = sessiondata.i_idunit;
    if (id_institusi !== "") {
      id_sp = id_institusi;
    }
    if (id_institusi === null) {
      id_sp = sessiondata.i_idunit;
    }
    let session = "";
    if (this.props.idSp !== undefined) {
      id_sp = this.props.idSp;
    }
    if (id_sp) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        id_sp +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    let tahun_siklus = localStorage.getItem("tahun_siklus");
    Axios.get(
      AppConfig.urlGetHistoricalPengaturanSiklus + id_sp + "/" + event + "/" + tahun_siklus + session
    )
      .then((res) => {
        this.setState({
          dataHistorical: res.data.result.data,
          display_datahistorical: true,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  handleChangeAlasan(event) {
    const { name, value } = event.target;
    this.setState({
      [name]:
        value === "belumada" ? 0 : value === "Masih dalam proses" ? 1 : "",
    });
    if (value === "lainnya") {
      this.setState({ isRadioSelected: false });
    } else {
      this.setState({ isRadioSelected: true });
    }
  }
  handleEditButtonP1 = () => {
    this.setState(
      {
        showEdit: true,
        statusajuanEdit: 1,
        statusEdit: 1,
        id_jenis_aturanEdit: 1,
        tautanEdit: this.state.get_pengaturan.t1.tautan,
        deskrispiEdit: this.state.get_pengaturan.t1.deskripsi,
        tanggal_penetapanEdit: Moments(
          this.state.get_pengaturan.t1.tanggal_penetapan
        ).format("YYYY-MM-DD"),
        id_ajuan_pengaturanEdit: this.state.get_pengaturan.t1
          .id_ajuan_pengaturan,
      },
      () => {
        console.log("Tanggal Penetapan: ", this.state.tanggal_penetapanEdit);
      }
    );
  };
  handleEditTidakAdaP1 = () => {
    this.setState({
      showTidakAdaEdit: true,
      statusEdit: 0,
      id_ajuan_pengaturanEdit: this.state.get_pengaturan.t1.id_ajuan_pengaturan,
    });
  };
  handleEditButtonP2 = () => {
    this.setState({
      showEdit: true,
      statusajuanEdit: 1,
      id_jenis_aturanEdit: 2,
      statusEdit: this.state.get_pengaturan.t2.status,
      tautanEdit: this.state.get_pengaturan.t2.tautan,
      deskrispiEdit: this.state.get_pengaturan.t2.deskripsi,
      tanggal_penetapanEdit: Moments(
        this.state.get_pengaturan.t2.tanggal_penetapan
      ).format("YYYY-MM-DD"),
      id_ajuan_pengaturanEdit: this.state.get_pengaturan.t2.id_ajuan_pengaturan,
    });
  };
  handleEditP2_unit = () => {
    this.setState({
      showEdit: true,
      statusajuanEdit: 1,
      statusEdit: 2,
      tautanEdit: this.state.get_pengaturan.t2.tautan,
      deskrispiEdit: this.state.get_pengaturan.t2.deskripsi,
      tanggal_penetapanEdit: Moments(
        this.state.get_pengaturan.t2.tanggal_penetapan
      ).format("YYYY-MM-DD"),
      id_ajuan_pengaturanEdit: this.state.get_pengaturan.t2.id_ajuan_pengaturan,
    });
  };
  handleEditP2_embedded = () => {
    this.setState({
      showEdit: true,
      statusajuanEdit: 1,
      statusEdit: 3,
      tautanEdit: this.state.get_pengaturan.t2.tautan,
      deskrispiEdit: this.state.get_pengaturan.t2.deskripsi,
      tanggal_penetapanEdit: Moments(
        this.state.get_pengaturan.t2.tanggal_penetapan
      ).format("YYYY-MM-DD"),
      id_ajuan_pengaturanEdit: this.state.get_pengaturan.t2.id_ajuan_pengaturan,
    });
  };
  handleEditP2_kombinasi = () => {
    this.setState({
      showEdit: true,
      statusajuanEdit: 1,
      statusEdit: 4,
      tautanEdit: this.state.get_pengaturan.t2.tautan,
      deskrispiEdit: this.state.get_pengaturan.t2.deskripsi,
      tanggal_penetapanEdit: Moments(
        this.state.get_pengaturan.t2.tanggal_penetapan
      ).format("YYYY-MM-DD"),
      id_ajuan_pengaturanEdit: this.state.get_pengaturan.t2.id_ajuan_pengaturan,
    });
  };
  handleEditButtonP3 = () => {
    this.setState({
      showEdit: true,
      statusajuanEdit: 1,
      statusEdit: 1,
      id_jenis_aturanEdit: 3,
      tautanEdit: this.state.get_pengaturan.t3.tautan,
      deskrispiEdit: this.state.get_pengaturan.t3.deskripsi,
      tanggal_penetapanEdit: Moments(
        this.state.get_pengaturan.t3.tanggal_penetapan
      ).format("YYYY-MM-DD"),
      id_ajuan_pengaturanEdit: this.state.get_pengaturan.t3.id_ajuan_pengaturan,
    });
  };
  handleEditTidakAdaP3 = () => {
    this.setState({
      showTidakAdaEdit: true,
      statusEdit: 0,
      id_ajuan_pengaturanEdit: this.state.get_pengaturan.t3.id_ajuan_pengaturan,
    });
  };
  handleEditButtonP4 = () => {
    this.setState({
      id_jenis_aturanEdit: 4,
      showEdit: true,
      statusajuanEdit: 1,
      statusEdit: 1,
      tautanEdit: this.state.get_pengaturan.t4.tautan,
      deskrispiEdit: this.state.get_pengaturan.t4.deskripsi,
      tanggal_penetapanEdit: Moments(
        this.state.get_pengaturan.t4.tanggal_penetapan
      ).format("YYYY-MM-DD"),
      id_ajuan_pengaturanEdit: this.state.get_pengaturan.t4.id_ajuan_pengaturan,
    });
  };
  handleEditTidakAdaP4 = () => {
    this.setState({
      showTidakAdaEdit: true,
      statusEdit: 0,
      id_ajuan_pengaturanEdit: this.state.get_pengaturan.t4.id_ajuan_pengaturan,
    });
  };
  handleEditButtonP5 = () => {
    this.setState({
      showEdit: true,
      id_jenis_aturanEdit: 5,
      statusajuanEdit: 1,
      statusEdit: 1,
      tautanEdit: this.state.get_pengaturan.t5.tautan,
      deskrispiEdit: this.state.get_pengaturan.t5.deskripsi,
      tanggal_penetapanEdit: Moments(
        this.state.get_pengaturan.t5.tanggal_penetapan
      ).format("YYYY-MM-DD"),
      id_ajuan_pengaturanEdit: this.state.get_pengaturan.t5.id_ajuan_pengaturan,
    });
  };
  handleEditTidakAdaP5 = () => {
    this.setState({
      showTidakAdaEdit: true,
      statusEdit: 0,
      id_ajuan_pengaturanEdit: this.state.get_pengaturan.t5.id_ajuan_pengaturan,
    });
  };
  handleEditButtonP6 = () => {
    this.setState(
      {
        showEdit: true,
        statusajuanEdit: 1,
        statusEdit: 1,
        id_jenis_aturanEdit: 6,
        tautanEdit: this.state.get_pengaturan.t6.tautan,
        deskrispiEdit: this.state.get_pengaturan.t6.deskripsi,
        tanggal_penetapanEdit: Moments(
          this.state.get_pengaturan.t6.tanggal_penetapan
        ).format("YYYY-MM-DD"),
        id_ajuan_pengaturanEdit: this.state.get_pengaturan.t6
          .id_ajuan_pengaturan,
      },
      () => {
        console.log(this.state.tanggal_penetapanEdit);
      }
    );
  };
  handleEditTidakAdaP6 = () => {
    this.setState({
      showTidakAdaEdit: true,
      statusEdit: 0,
      id_ajuan_pengaturanEdit: this.state.get_pengaturan.t6.id_ajuan_pengaturan,
    });
  };
  handleClose() {
    this.setState({
      showHistorical: false,
      showTidakAdaEdit: false,
      showAda: false,
      showTidakAda: false,
      showEdit: false,
      // insert state
      id_ajuan_pengaturan: "",
      id_jenis_aturan: "",
      status: "",
      keterangan: "",
      tautan: "",
      deskripsi: "",
      tanggal_penetapan: "",
      // UPDATE STATE
      statusajuanEdit: "",
      id_ajuan_pengaturanEdit: "",
      tautanEdit: "",
      deskrispiEdit: "",
      tanggal_penetapanEdit: "",
    });
  }
  handleTahunSiklusChanged = () => {
    this.setState({ loadingBar: true });
    this.componentDidMount();
  };
  componentWillUnmount() {
    window.removeEventListener("tahunSiklusChanged", this.handleTahunSiklusChanged);
    window.removeEventListener("storage", this.handleTahunSiklusChanged);
  }
  componentDidMount() {
    if (!this.hasYearSelectListener) {
      window.addEventListener("tahunSiklusChanged", this.handleTahunSiklusChanged);
      window.addEventListener("storage", this.handleTahunSiklusChanged);
      this.hasYearSelectListener = true;
    }
    // if(this.state.display === false){
    //     this.setState({
    //         get_pengaturan: this.props.dataSPMI.get_pengaturan.data.result.pengaturan,
    //     })
    // }
    let id_institusi = localStorage.getItem("id_sp_temp");
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    const sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let id_sp = sessiondata.i_idunit;
    if (id_institusi !== "") {
      id_sp = id_institusi;
    }
    if (id_institusi === null) {
      id_sp = sessiondata.i_idunit;
    }
    let session = "";
    if (this.props.idSp !== undefined) {
      id_sp = this.props.idSp;
    }
    let session_tahun_siklus = localStorage.getItem("tahun_siklus")
    if (id_sp) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        id_sp +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    Axios.get(AppConfig.urlGetPengaturan + id_sp + "/" + session_tahun_siklus + session)
      .then((res) => {
        // console.log(res.data.result.pengaturan);
        this.setState({
          get_pengaturan: res.data.result.pengaturan,
          p1_status:
            res.data.result.pengaturan.t1 !== undefined
              ? res.data.result.pengaturan.t1.status
              : 0,
          p2_status:
            res.data.result.pengaturan.t2 !== undefined
              ? res.data.result.pengaturan.t2.status
              : 0,
          p3_status:
            res.data.result.pengaturan.t3 !== undefined
              ? res.data.result.pengaturan.t3.status
              : 0,
          p4_status:
            res.data.result.pengaturan.t4 !== undefined
              ? res.data.result.pengaturan.t4.status
              : 0,
          p5_status:
            res.data.result.pengaturan.t5 !== undefined
              ? res.data.result.pengaturan.t5.status
              : 0,
          p6_status:
            res.data.result.pengaturan.t6 !== undefined
              ? res.data.result.pengaturan.t6.status
              : 0,
          loadingBar: false,
        });
      })
      .catch((err) => {
        this.setState({
          loadingBar: false,
        });
        console.log(err);
      });
  }
  onInputChangePengaturan = (e, type) => {
    this.setState({
      [type]: e.target.value,
    });
  };
  handleSavePengaturan = (e) => {
    swal({
      title: "Anda yakin?",
      text: "Pastikan verifikator dapat melihat dokumen yang Anda upload!",
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then((willSave) => {
      if (willSave) {
        let userdata = JSON.parse(localStorage.getItem("userdata"));
        let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
        let session = "";
        if (userdata) {
          session =
            // "?token="+userdata.token+
            "?id_pengguna=" +
            userdata.id_pengguna +
            "&id_unit=" +
            sessiondata.i_idunit +
            "&id_role=" +
            sessiondata.i_idrole;
        }
        e.preventDefault();
        swal({
          title: "Apakah anda yakin?",
          text: "Data pengaturan akan disimpan sebagai historical!",
          icon: "warning",
          buttons: true,
          dangerMode: true,
        }).then((willDelete) => {
          if (willDelete) {
            let session_tahun_siklus = localStorage.getItem("tahun_siklus")
            var formData = new FormData();
            // if (this.state.id_ajuan_pengaturanEdit) {
            //   formData.append('data[id_ajuan_pengaturan]', this.state.id_ajuan_pengaturanEdit);
            // }
            formData.append(
              "data[id_jenis_aturan]",
              this.state.id_jenis_aturan
            );
            formData.append("data[tautan]", this.state.tautan);
            formData.append("data[deskripsi]", this.state.deskripsi);
            formData.append("data[keterangan]", this.state.keterangan);
            formData.append("data[tahun_siklus]", session_tahun_siklus);
            formData.append(
              "data[tanggal_penetapan]",
              this.state.tanggal_penetapan
            );
            formData.append("data[status]", this.state.status);
            formData.append("data[id_sp]", sessiondata.i_idunit);
            this.setState({ loading: true });
            Axios.defaults.headers.post["Content-Type"] =
              "application/x-www-form-urlencoded";
            Axios.post(AppConfig.urlAPiPostDataPT + session, formData)
              .then((res) => {
                swal({
                  title: "Berhasil!",
                  text: "pengaturan berhasil!",
                  icon: "success",
                  button: "OK!",
                });
                this.componentDidMount();
                this.setState({
                  id_jenis_aturan: "",
                  tautan: "",
                  deskripsi: "",
                  tanggal_penetapan: "",
                  status: "",
                  id_sp: "",
                  keterangan: "",
                  loading: false,
                  showHistorical: false,
                  showTidakAdaEdit: false,
                  showAda: false,
                  showTidakAda: false,
                  showEdit: false,
                });
                console.log(res);
              })
              .catch((err) => {
                swal({
                  title: "Gagal!",
                  text: "pengaturan gagal ditambahkan!",
                  icon: "error",
                  button: "OK!",
                });
                // alert("GAGAL")
                this.setState({
                  id_jenis_aturan: "",
                  keterangan: "",
                  tautan: "",
                  deskripsi: "",
                  tanggal_penetapan: "",
                  status: "",
                  id_sp: "",
                  loading: false,
                  showHistorical: false,
                  showTidakAdaEdit: false,
                  showAda: false,
                  showTidakAda: false,
                  showEdit: false,
                });
              });
            // swal("Anda telah menyetujui !", {
            //   icon: "success",
            // });
          } else {
            swal("Anda telah membatalkan pengaturan!");
          }
        });
      } else {
        swal("Anda telah membatalkan pengaturan!");
      }
    });
  };
  handleSavePengaturanEdit = (e) => {
    swal({
      title: "Anda yakin?",
      text: "Pastikan verifikator dapat melihat dokumen yang Anda upload!",
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then((willSave) => {
      if (willSave) {
        let userdata = JSON.parse(localStorage.getItem("userdata"));
        let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
        let session = "";
        if (userdata) {
          session =
            // "?token="+userdata.token+
            "?id_pengguna=" +
            userdata.id_pengguna +
            "&id_unit=" +
            sessiondata.i_idunit +
            "&id_role=" +
            sessiondata.i_idrole;
        }
        e.preventDefault();
        swal({
          title: "Apakah anda yakin?",
          text: "Data pengaturan sebelumnya akan dijadikan data historical!",
          icon: "warning",
          buttons: true,
          dangerMode: true,
        }).then((willDelete) => {
          if (willDelete) {
            this.setState({ loading: true });
            let session_tahun_siklus = localStorage.getItem("tahun_siklus")
            var formData = new FormData();
            formData.append("data[statusajuan]", this.state.statusajuanEdit);
            // formData.append('data[id_ajuan_pengaturan]', this.state.id_ajuan_pengaturanEdit);
            formData.append("data[tautan]", this.state.tautanEdit);
            formData.append("data[deskripsi]", this.state.deskrispiEdit);
            formData.append(
              "data[tanggal_penetapan]",
              this.state.tanggal_penetapanEdit
            );
            formData.append("data[tahun_siklus]", session_tahun_siklus);
            formData.append("data[keterangan]", this.state.keteranganEdit);
            formData.append("data[status]", this.state.statusEdit);
            formData.append(
              "data[id_jenis_aturan]",
              this.state.id_jenis_aturanEdit
            );
            // formData.append('data[id_sp]', this.state.id_sp);
            formData.append("data[id_sp]", sessiondata.i_idunit);
            Axios.defaults.headers.post["Content-Type"] =
              "application/x-www-form-urlencoded";
            Axios.post(AppConfig.urlAPiPostDataPT + session, formData)
              .then((res) => {
                swal({
                  title: "Berhasil!",
                  text: "Pengaturan berhasil diperbarui!",
                  icon: "success",
                  button: "OK!",
                });
                this.componentDidMount();
                this.setState({
                  showEdit: false,
                  id_ajuan_pengaturanEdit: "",
                  tautanEdit: "",
                  deskrispiEdit: "",
                  tanggal_penetapanEdit: "",
                  loading: false,
                });
                console.log(res);
              })
              .catch((err) => {
                swal({
                  title: "Gagal!",
                  text: "pengaturan gagal diperbarui!",
                  icon: "error",
                  button: "OK!",
                });
                // alert("GAGAL")
                this.setState({
                  showEdit: false,
                  id_ajuan_pengaturanEdit: "",
                  tautanEdit: "",
                  deskrispiEdit: "",
                  tanggal_penetapanEdit: "",
                  loading: false,
                });
              });
            // swal("Poof! Your imaginary file has been deleted!", {
            //   icon: "success",
            // });
          } else {
            swal("Anda telah membatalkan pengaturan!");
          }
        });
      } else {
        swal("Anda telah membatalkan pengaturan!");
      }
    });
  };
  handleShowP1(event) {
    const userdata = JSON.parse(localStorage.getItem("sessiondata"));
    const { name, value } = event.target;
    // this.setState({ [name]: value ==="ada" ? 1 : 0 });
    if (value === "ada") {
      this.setState({
        showAda: true,
        id_jenis_aturan: 1,
        status: 1,
        id_sp: userdata.i_idunit,
      });
    } else {
      this.setState({
        showTidakAda: true,
        id_jenis_aturan: 1,
        status: 0,
        tanggal_penetapan: null,
        id_sp: userdata.i_idunit,
      });
      if (value === this.state.keterangan) {
        this.setState({ isRadioSelected: false });
      } else {
        this.setState({ isRadioSelected: true });
      }
    }
  }
  handleOrganisasiP2(event) {
    const userdata = JSON.parse(localStorage.getItem("sessiondata"));
    const { name, value } = event.target;
    this.setState({
      [name]: value === "dalamunit" ? 2 : value === "kombinasi" ? 4 : 3,
    });
    console.log("name", name);
    console.log("value", value);
    if (value === "dalamunit") {
      this.setState({
        showAda: true,
        id_jenis_aturan: 2,
        status: 2,
        id_sp: userdata.i_idunit,
      });
    } else if (value === "kombinasi") {
      this.setState({
        showAda: true,
        id_jenis_aturan: 2,
        status: 4,
        id_sp: userdata.i_idunit,
      });
    } else {
      this.setState({
        showAda: true,
        id_jenis_aturan: 2,
        status: 3,
        id_sp: userdata.i_idunit,
      });
    }
  }
  handleShowP3(event) {
    const userdata = JSON.parse(localStorage.getItem("sessiondata"));
    const { name, value } = event.target;
    // this.setState({ [name]: value ==="ada" ? 1 : 0 });
    if (value === "ada") {
      this.setState({
        showAda: true,
        id_jenis_aturan: 3,
        status: 1,
        id_sp: userdata.i_idunit,
      });
    } else {
      this.setState({
        showTidakAda: true,
        id_jenis_aturan: 3,
        status: 0,
        tanggal_penetapan: null,
        id_sp: userdata.i_idunit,
      });
      if (value === this.state.keterangan) {
        this.setState({ isRadioSelected: false });
      } else {
        this.setState({ isRadioSelected: true });
      }
    }
  }
  handleShowP4(event) {
    const userdata = JSON.parse(localStorage.getItem("sessiondata"));
    const { name, value } = event.target;
    // this.setState({ [name]: value ==="ada" ? 1 : 0 });
    if (value === "ada") {
      this.setState({
        showAda: true,
        id_jenis_aturan: 4,
        status: 1,
        id_sp: userdata.i_idunit,
      });
    } else {
      this.setState({
        showTidakAda: true,
        id_jenis_aturan: 4,
        status: 0,
        tanggal_penetapan: null,
        id_sp: userdata.i_idunit,
      });
      if (value === this.state.keterangan) {
        this.setState({ isRadioSelected: false });
      } else {
        this.setState({ isRadioSelected: true });
      }
    }
  }
  handleShowP5(event) {
    const userdata = JSON.parse(localStorage.getItem("sessiondata"));
    const { name, value } = event.target;
    // this.setState({ [name]: value ==="ada" ? 1 : 0 });
    if (value === "ada") {
      this.setState({
        showAda: true,
        id_jenis_aturan: 5,
        status: 1,
        id_sp: userdata.i_idunit,
      });
    } else {
      this.setState({
        showTidakAda: true,
        id_jenis_aturan: 5,
        status: 0,
        tanggal_penetapan: null,
        id_sp: userdata.i_idunit,
      });
      if (value === this.state.keterangan) {
        this.setState({ isRadioSelected: false });
      } else {
        this.setState({ isRadioSelected: true });
      }
    }
  }
  handleShowP6(event) {
    const userdata = JSON.parse(localStorage.getItem("sessiondata"));
    const { name, value } = event.target;
    // this.setState({ [name]: value ==="ada" ? 1 : 0 });
    if (value === "ada") {
      this.setState({
        showAda: true,
        id_jenis_aturan: 6,
        status: 1,
        id_sp: userdata.i_idunit,
      });
    } else {
      this.setState({
        showTidakAda: true,
        id_jenis_aturan: 6,
        status: 0,
        tanggal_penetapan: null,
        id_sp: userdata.i_idunit,
      });
      if (value === this.state.keterangan) {
        this.setState({ isRadioSelected: false });
      } else {
        this.setState({ isRadioSelected: true });
      }
    }
  }

  showDialogDelete(id) {
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    swal({
      title: "Apakah anda yakin?",
      text: "Catatan akan terhapus, dan tidak tercatat pada historical",
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then((willDelete) => {
      if (willDelete) {
        this.setState({ loading: true });
        Axios
          .get(AppConfig.urlDeletePengaturan + id + session)
          .then((res) => {
            swal({
              title: "Berhasil!",
              text: "Pengaturan Evaluasi berhasil!",
              icon: "success",
              button: "OK!",
            });
            this.componentDidMount();
            this.setState({
              loading: false,
              showAda: false,
              showEdit: false,
              id_jenis_aturan: "",
              id_sp: "",
              tautan: "",
              keterangan: "",
              tanggal_penetapan: "",
              status: "",
            });
            console.log(res);
          })
          .catch((err) => {
            swal({
              title: "Gagal!",
              text: "Pengaturan gagal dihapus!",
              icon: "error",
              button: "OK!",
            });
            this.setState({
              loading: false,
            });
          });
      }
    });
  }

  render() {
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    // console.log("data didalam =", this.props.dataSPMI.pengaturan);
    let {
      get_pengaturan,
      p1_status,
      p2_status,
      p3_status,
      p4_status,
      p5_status,
      p6_status,
      dataHistorical,
      showAda,
      showTidakAdaEdit,
      showTidakAda,
      showHistorical,
      isRadioSelected,
      loading,
      tautan,
      deskripsi,
      tanggal_penetapan,
      id_jenis_aturan,
      id_sp,
      keterangan,
      status,
    } = this.state;
    // console.log("get Detils", this.state.get_jenis);
    // console.log("get data", this.state.dataHistorical);
    let display_historical = [];
    if (this.state.display_datahistorical === true) {
      dataHistorical.map((list, i) => {
        display_historical.push(
          <>
            <tr>
              <td style={{ textAlign: "center" }}>
                {list.status === 1 ? (
                  "Ada"
                ) : list.status === 0 ? (
                  "Tidak ada"
                ) : list.status === 2 ? (
                  "Dalam unit tersendiri"
                ) : list.status === 3 ? (
                  <>
                    <i>Embedded</i>dalam organisasi institusi
                  </>
                ) : list.status === 4 ? (
                  <>
                    <i>embedded</i>Kombinasi unit pengelola dan{" "}
                  </>
                ) : (
                  "-"
                )}
              </td>
              <td style={{ textAlign: "center" }}>
                {list.tautan === "null" ? (
                  list.keterangan
                ) : (
                  <a target="_blank" className="menu-link" href={list.tautan}>
                    <Button
                      className="btn btn-icon btn-light btn-sm"
                      style={{
                        minWidth: "50px",
                        borderRadius: "12px",
                        background: "#A9C6DE",
                      }}
                    >
                      <i
                        class="flaticon-attachment"
                        style={{ color: "#3F4254", fontSize: "14px" }}
                      ></i>
                    </Button>
                  </a>
                )}
              </td>
              <td style={{ textAlign: "center" }}>
                {list.statusajuan === 3 ? (
                  <Badge
                    pill
                    variant="success"
                    style={{
                      backgroundColor: "#BEF2FF",
                      color: "#334443",
                      fontSize: "12px",
                    }}
                  >
                    <Badge variant="light">
                      {" "}
                      <span style={{ color: "#37bf30" }}>✔</span>
                    </Badge>
                    &nbsp;&nbsp;&nbsp; Terverifikasi
                  </Badge>
                ) : list.statusajuan === 1 ? (
                  <Badge
                    pill
                    variant="secondary"
                    style={{
                      backgroundColor: "#BEF2FF",
                      color: "#334443",
                      fontSize: "12px",
                    }}
                  >
                    <Badge variant="light">
                      {" "}
                      <span style={{ color: "#858585" }}>•</span>
                    </Badge>
                    &nbsp;&nbsp;&nbsp; Belum Terverifikasi
                  </Badge>
                ) : (
                  <Badge
                    pill
                    variant="secondary"
                    style={{
                      backgroundColor: "#BEF2FF",
                      color: "#334443",
                      fontSize: "12px",
                    }}
                  >
                    -
                  </Badge>
                )}
              </td>
              <td style={{ textAlign: "center" }}>
                <Moment
                  format="DD/MM/YYYY"
                  date={
                    list.tanggal_penetapan === "null"
                      ? "-"
                      : list.tanggal_penetapan
                  }
                />
              </td>
              <td style={{ textAlign: "center" }}>{(list.catatan !== "null" ? list.catatan : "-")}</td>
            </tr>
          </>
        );
      });
    } else {
      display_historical = (
        <>
          <tr>
            <td colSpan="5">
              <LinearProgress color="secondary" variant="query" />
            </td>
          </tr>
        </>
      );
    }
    // console.log("data id_jenis_aturan", this.state.id_ajuan_pengaturanEdit);
    // console.log("data tanggal_penetapanEdit", this.state.tanggal_penetapanEdit);
    // console.log("data statusajuanEdit", this.state.statusajuanEdit);
    // console.log("data keteranganEdit", this.state.keteranganEdit);
    // console.log("data statusEdit", this.state.statusEdit);
    // console.log("data session", sessiondata.i_idrole);
    let {
      p1status,
      p1statuslist,
      p1tautan,
      p1tanggal,
      p1tahun,
      p1verify,
      p1document,
      p1keterangan,
      p1edit,
      p1delete,
      p1aprove,
      p1buttonHistorical,
      p2status,
      p2statuslist,
      p2tautan,
      p2tanggal,
      p2tahun,
      p2document,
      p2verify,
      p2edit,
      p2delete,
      p2aprove,
      p2buttonHistorical,
      p3status,
      p3statuslist,
      p3tautan,
      p3tanggal,
      p3tahun,
      p3document,
      p3verify,
      p3keterangan,
      p3edit,
      p3aprove,
      p3buttonHistorical,
      p4status,
      p4statuslist,
      p4tautan,
      p4tanggal,
      p4tahun,
      p4document,
      p4verify,
      p4keterangan,
      p4edit,
      p4aprove,
      p4buttonHistorical,
      p5status,
      p5statuslist,
      p5tautan,
      p5tanggal,
      p5tahun,
      p5document,
      p5verify,
      p5keterangan,
      p5edit,
      p5aprove,
      p5buttonHistorical,
      p6status,
      p6statuslist,
      p6tautan,
      p6tanggal,
      p6tahun,
      p6document,
      p6verify,
      p6keterangan,
      p6edit,
      p6aprove,
      p6buttonHistorical,
    } = "";
    let pengaturan_1,
      pengaturan_2,
      pengaturan_3,
      pengaturan_4,
      pengaturan_5,
      pengaturan_6 = "";
    // PENGATURAN 1 PENGELOLAAN
    if (get_pengaturan.t1) {
      console.log("data t1", get_pengaturan.t1)
      if (get_pengaturan.t1.status === 0) {
        p1statuslist = (
          <>
            <td style={{ textAlign: "center" }}>Tidak Ada</td>
          </>
        );
      } else if (get_pengaturan.t1.status === 1) {
        p1statuslist = (
          <>
            <td style={{ textAlign: "center" }}>Ada</td>
          </>
        );
      } else if (get_pengaturan.t1.status === 2) {
        p1statuslist = (
          <>
            <td style={{ textAlign: "center" }}>Dalam unit tersendiri</td>
          </>
        );
      } else if (get_pengaturan.t1.status === 3) {
        p1statuslist = (
          <>
            <td style={{ textAlign: "center" }}>
              <i>Embedded</i> dalam organisasi institusi
            </td>
          </>
        );
      } else if (get_pengaturan.t1.status === 4) {
        p1statuslist = (
          <>
            <td style={{ textAlign: "center" }}>
              Kombinasi unit pengelola dan <i>embedded</i>
            </td>
          </>
        );
      } else {
        p1statuslist = (
          <>
            <td style={{ textAlign: "center" }}>-</td>
          </>
        );
      }
      p1buttonHistorical = (
        <>
          <Button
            onClick={() => this.handleShowHistorical(1)}
            className="btn btn-icon btn-success btn-sm"
            style={{ minWidth: "50px", borderRadius: "12px", margin: "0px 2px" }}
          >
            <i
              class="flaticon2-time"
              style={{ color: "#ffffff", fontSize: "14px" }}
            ></i>
          </Button>
        </>
      );
      let p1buttonInterface = (
        <>
          <Button
            onClick={() => this.handleClickInterface("1")}
            className="btn btn-icon btn-warning btn-sm"
            style={{ minWidth: "50px", borderRadius: "12px", margin: "0px 2px" }}
          >
            <i
              class="flaticon-interface-4"
              style={{ color: "#ffffff", fontSize: "14px" }}
            ></i>
          </Button>
        </>
      );
      if (sessiondata.i_idrole !== 3 && sessiondata.i_idrole !== "3") {
        p1buttonInterface = ""
      }
      if(get_pengaturan.t1.statusajuan === 3){
        p1buttonInterface = ""
      }
      p1aprove = (
        <>
          {/* ajuan-pengaturan/detail/ */}
          <Link
            to={
              "/ajuan-pengaturan/detail/" +
              get_pengaturan.t1.id_ajuan_pengaturan
            }
          >
            {/* <i class="flaticon-settings-1" style={{color: '#ffffff', fontSize: '14px'}}></i> */}
            <Button
              className="btn btn-icon btn-primary btn-sm"
              style={{ minWidth: "50px", borderRadius: "12px", margin: "0px 2px" }}
            >
              <i
                class="flaticon-eye"
                style={{ color: "#ffffff", fontSize: "14px" }}
              ></i>
            </Button>
          </Link>
        </>
      );
      p1tautan = (
        <>
          <td style={{ textAlign: "center" }}>
            <Button
              href={get_pengaturan.t1.tautan}
              target="_blank"
              className="btn btn-icon btn-light btn-sm"
              style={{
                minWidth: "50px",
                borderRadius: "12px",
                background: "#A9C6DE",
              }}
            >
              <i
                class="flaticon-attachment"
                style={{ color: "#3F4254", fontSize: "14px" }}
              ></i>
            </Button>
          </td>
        </>
      );
      p1tanggal = (
        <>
          <td
            style={{
              textAlign: "center",
              fontSize: "12px",
              verticalAlign: "top",
            }}
          >
            <Moment
              date={
                get_pengaturan.t1.tanggal_penetapan
                  ? get_pengaturan.t1.tanggal_penetapan
                  : "loading .."
              }
              format="DD/MM/YYYY"
            />
          </td>
        </>
      );
      p1tahun = (
        <>
          <td
            style={{
              textAlign: "center",
              fontSize: "12px",
              verticalAlign: "top",
            }}
          >
            {get_pengaturan.t1.tahun_siklus
              ? get_pengaturan.t1.tahun_siklus
              : "loading .."}
          </td>
        </>
      );
      p1keterangan = (
        <>
          <td style={{ textAlign: "center", fontSize: "12px" }}>
            {this.state.get_pengaturan.t1.keterangan
              ? this.state.get_pengaturan.t1.keterangan
              : "loading.."}
          </td>
        </>
      );
      p1edit = (
        <>
          <Button
            onClick={this.handleEditButtonP1}
            className="btn btn-icon btn-warning btn-sm"
            style={{
              minWidth: "50px",
              borderRadius: "12px",
              fontSize: "12px",
              color: "#fff",
            }}
          >
            <i
              class="flaticon-edit"
              style={{ color: "#ffffff", fontSize: "14px" }}
            ></i>
          </Button>
        </>
      );
      p1delete = (
        <Button
          onClick={() =>
            this.showDialogDelete(
              this.state.get_pengaturan.t1.id_ajuan_pengaturan
            )
          }
          className="btn btn-icon btn-danger btn-sm"
          style={{
            minWidth: "50px",
            borderRadius: "12px",
            marginLeft: "5px",
          }}
        >
          <i
            className="flaticon-delete"
            style={{ color: "#FFFFFF", fontSize: "14px" }}
          ></i>
        </Button>
      );
      if (get_pengaturan.t1.statusajuan === 1) {
        p1verify = (
          <>
            <td
              style={{
                textAlign: "center",
                fontSize: "12px",
                verticalAlign: "top",
              }}
            >
              <Badge
                pill
                variant="secondary"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                Belum Terverifikasi
              </Badge>
            </td>
          </>
        );
      } else if (get_pengaturan.t1.statusajuan === 3) {
        p1verify = (
          <>
            <td
              style={{
                textAlign: "center",
                fontSize: "12px",
                verticalAlign: "top",
              }}
            >
              <Badge
                pill
                variant="success"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                <Badge variant="light">
                  {" "}
                  <span style={{ color: "#37bf30" }}>✔</span>
                </Badge>
                &nbsp;&nbsp;&nbsp; Terverifikasi
              </Badge>
            </td>
          </>
        );
      } else {
        p1verify = (
          <>
            <td
              style={{
                textAlign: "center",
                fontSize: "12px",
                verticalAlign: "top",
              }}
            >
              <Badge
                pill
                variant="secondary"
                style={{ backgroundColor: "#CCCCCC", color: "#FFFFFF" }}
              >
                -
              </Badge>
            </td>
          </>
        );
      }
      if (get_pengaturan.t1.dokumen_valid === "0") {
        p1document = (
          <>
            <td
              style={{
                textAlign: "center",
                fontSize: "12px",
                verticalAlign: "top",
              }}
            >
              <Badge
                pill
                variant="warning"
                style={{
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                Belum Valid
              </Badge>
            </td>
          </>
        );
      } else if (get_pengaturan.t1.dokumen_valid === "1") {
        p1document = (
          <>
            <td
              style={{
                textAlign: "center",
                fontSize: "12px",
                verticalAlign: "top",
              }}
            >
              <Badge
                pill
                variant="success"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                Sudah Valid
              </Badge>
            </td>
          </>
        );
      } else {
        p1document = (
          <>
            <td
              style={{
                textAlign: "center",
                fontSize: "12px",
                verticalAlign: "top",
              }}
            >
              <Badge
                pill
                variant="secondary"
                style={{ backgroundColor: "#CCCCCC", color: "#FFFFFF" }}
              >
                Dokumen belum diverifikasi
              </Badge>
            </td>
          </>
        );
      }
      if (get_pengaturan.t1.status === 1) {
        p1status = (
          <>
            {sessiondata.i_idrole === 3 || sessiondata.i_idrole === "3" ? (
              <td style={{ fontSize: "12px" }}>
                <span>
                  <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                    <input
                      checked={p1_status === 1}
                      type="radio"
                      name="pengaturanspmi"
                      value="ada"
                    />
                    &nbsp; Ada
                  </label>
                </span>
                &nbsp; &nbsp;
                <span>
                  <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                    <input
                      checked={p1_status === 0}
                      type="radio"
                      name="pengaturanspmi"
                      value="tidakada"
                      onChange={this.handleShowP1}
                    />
                    &nbsp; Tidak ada
                  </label>
                </span>
              </td>
            ) : (
              p1statuslist
            )}
            {p1tautan}
            {p1tanggal}
            {p1tahun}
            {p1verify}
            {p1document}
          </>
        );
        pengaturan_1 = (
          <>
            <tr>
              <td style={{ fontSize: "12px", verticalAlign: "middle" }}>
                Kebijakan SPMI
              </td>
              {p1status}
              <td className="text-center pr-0">
                {// SUPER ADMIN
                  sessiondata.i_idrole === 1 ||
                    sessiondata.i_idrole === "1" ||
                    // BELMAWA
                    sessiondata.i_idrole === 10 ||
                    sessiondata.i_idrole === "10" ||
                    // REVIEWER
                    sessiondata.i_idrole === 2013 ||
                    sessiondata.i_idrole === "2013"
                    ? p1aprove
                    : p1aprove}
                {sessiondata.i_idrole === 3 || sessiondata.i_idrole === "3"
                  ? get_pengaturan.t1.statusajuan === 1 || (get_pengaturan.t1.dokumen_valid === "0" || get_pengaturan.t1.dokumen_valid === "null") ? p1edit : ""
                  : ""}
                {p1buttonHistorical}
                {p1buttonInterface}
                {sessiondata.i_idrole === 3 || sessiondata.i_idrole === "3" ? p1delete : ""}
              </td>
            </tr>
          </>
        );
      } else if (get_pengaturan.t1.status === 0) {
        p1status = (
          <>
            <td style={{ fontSize: "12px" }}>
              <span>
                <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                  <input
                    type="radio"
                    checked={p1_status === 1}
                    name="pengaturanspmi"
                    value="ada"
                    onChange={this.handleShowP1}
                  />
                  &nbsp; Ada
                </label>
              </span>
              &nbsp;&nbsp;
              <span>
                <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                  <input
                    checked
                    type="radio"
                    name="pengaturanspmi"
                    value="tidakada"
                    onChange={this.handleShowP1}
                  />
                  &nbsp; Tidak ada
                </label>
              </span>
            </td>
            {p1keterangan}
            {p1tanggal}
            {p1tahun}
            {p1verify}
          </>
        );
        pengaturan_1 = (
          <>
            <tr>
              <td style={{ fontSize: "12px" }}>
                Kebijakan SPMI
              </td>
              {p1status}
              <td className="text-center pr-0">
                {p1buttonHistorical}
                {p1buttonInterface}
              </td>
            </tr>
          </>
        );
      }
    } else {
      pengaturan_1 = (
        <>
          <tr>
            <td style={{ fontSize: "12px" }}>
              Kebijakan SPMI
            </td>
            {sessiondata.i_idrole === 3 || sessiondata.i_idrole === "3" ? (
              <td style={{ fontSize: "12px", fontSize: "12px" }}>
                <span>
                  <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                    <input
                      type="radio"
                      checked={p1_status === 1}
                      name="pengaturanspmi"
                      value="ada"
                      onChange={this.handleShowP1}
                    />
                    &nbsp; Ada
                  </label>
                </span>
                &nbsp;&nbsp;
                <span>
                  <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                    <input
                      checked={p1_status === 0}
                      type="radio"
                      name="pengaturanspmi"
                      value="tidakada"
                      onChange={this.handleShowP1}
                    />{" "}
                    Tidak ada
                  </label>
                </span>
              </td>
            ) : (
              <td style={{ textAlign: "center", fontSize: "12px" }}>-</td>
            )}
            <td colspan="5" style={{ fontSize: "12px" }}>
              Perguruan Tinggi wajib mengisi terkait Ada / Tidak ada Pengaturan
              Kebijakan SPMI
            </td>
            <td className="text-center pr-0">
              {sessiondata.i_idrole === 3 || sessiondata.i_idrole === "3" ? (
                <Button
                  onClick={() => this.handleClickInterface("1")}
                  className="btn btn-icon btn-warning btn-sm"
                  style={{ minWidth: "50px", borderRadius: "12px" }}
                >
                  <i
                    class="flaticon-interface-4"
                    style={{ color: "#ffffff", fontSize: "14px" }}
                  ></i>
                </Button>
              ) : (
                ""
              )}
            </td>
          </tr>
        </>
      );
    }
    // PENGATURAN 2 ORGANISASI
    if (get_pengaturan.t2) {
      if (get_pengaturan.t2.status === 0) {
        p2statuslist = (
          <>
            <td style={{ textAlign: "center", fontSize: "12px" }}>Tidak Ada</td>
          </>
        );
      } else if (get_pengaturan.t2.status === 1) {
        p2statuslist = (
          <>
            <td style={{ textAlign: "center", fontSize: "12px" }}>Ada</td>
          </>
        );
      } else if (get_pengaturan.t2.status === 2) {
        p2statuslist = (
          <>
            <td style={{ textAlign: "center", fontSize: "12px" }}>
              Dalam unit tersendiri
            </td>
          </>
        );
      } else if (get_pengaturan.t2.status === 3) {
        p2statuslist = (
          <>
            <td style={{ textAlign: "center", fontSize: "12px" }}>
              <i>Embedded</i> dalam organisasi institusi
            </td>
          </>
        );
      } else if (get_pengaturan.t2.status === 4) {
        p2statuslist = (
          <>
            <td style={{ textAlign: "center", fontSize: "12px" }}>
              Kombinasi unit pengelola dan <i>embedded</i>
            </td>
          </>
        );
      } else {
        p2statuslist = (
          <>
            <td style={{ textAlign: "center", fontSize: "12px" }}>-</td>
          </>
        );
      }
      p2buttonHistorical = (
        <>
          <Button
            onClick={() => this.handleShowHistorical(2)}
            className="btn btn-icon btn-success btn-sm"
            style={{ minWidth: "50px", borderRadius: "12px", margin: "0px 2px" }}
          >
            <i
              class="flaticon2-time"
              style={{ color: "#ffffff", fontSize: "14px" }}
            ></i>
          </Button>
        </>
      );
      let p2buttonInterface = (
        <>
          <Button
            onClick={() => this.handleClickInterface(get_pengaturan.t2.id_jenis_aturan)}
            className="btn btn-icon btn-warning btn-sm"
            style={{ minWidth: "50px", borderRadius: "12px", margin: "0px 2px" }}
          >
            <i
              class="flaticon-interface-4"
              style={{ color: "#ffffff", fontSize: "14px" }}
            ></i>
          </Button>
        </>
      );
      if (sessiondata.i_idrole !== 3 && sessiondata.i_idrole !== "3") {
        p2buttonInterface = ""
      }
      if(get_pengaturan.t2.statusajuan === 3){
        p2buttonInterface = ""
      }
      p2aprove = (
        <>
          <Link
            to={
              "/ajuan-pengaturan/detail/" +
              get_pengaturan.t2.id_ajuan_pengaturan
            }
          >
            <Button
              className="btn btn-icon btn-primary btn-sm"
              style={{ minWidth: "50px", borderRadius: "12px", margin: "0px 2px" }}
            >
              <i
                class="flaticon-eye"
                style={{ color: "#ffffff", fontSize: "14px" }}
              ></i>
            </Button>
          </Link>
        </>
      );
      p2tautan = (
        <>
          <td style={{ textAlign: "center", fontSize: "12px" }}>
            <Button
              href={get_pengaturan.t2.tautan}
              target="_blank"
              className="btn btn-icon btn-light btn-sm"
              style={{
                minWidth: "50px",
                borderRadius: "12px",
                background: "#A9C6DE",
              }}
            >
              <i
                class="flaticon-attachment"
                style={{ color: "#3F4254", fontSize: "14px" }}
              ></i>
            </Button>
          </td>
        </>
      );
      p2tanggal = (
        <>
          <td style={{ textAlign: "center", fontSize: "12px" }}>
            <Moment
              date={
                get_pengaturan.t2.tanggal_penetapan
                  ? get_pengaturan.t2.tanggal_penetapan
                  : "loading .."
              }
              format="DD/MM/YYYY"
            />
          </td>
        </>
      );
      p2tahun = (
        <>
          <td style={{ textAlign: "center", fontSize: "12px" }}>
            {get_pengaturan.t2.tahun_siklus
              ? get_pengaturan.t2.tahun_siklus
              : "loading .."}
          </td>
        </>
      );
      // p2keterangan = <>
      //     <td style={{textAlign:'center'}}>
      //       {this.state.get_pengaturan.t2.keterangan ? this.state.get_pengaturan.t2.keterangan : 'loading..'}
      //     </td>
      // </>;
      p2edit = (
        <>
          <Button
            onClick={this.handleEditButtonP2}
            className="btn btn-icon btn-warning btn-sm"
            style={{ minWidth: "50px", borderRadius: "12px", margin: "0px 2px" }}
          >
            <i
              class="flaticon-edit"
              style={{ color: "#ffffff", fontSize: "14px" }}
            ></i>
          </Button>
        </>
      );
      p2delete = (
        <Button
          onClick={() =>
            this.showDialogDelete(
              this.state.get_pengaturan.t2.id_ajuan_pengaturan
            )
          }
          className="btn btn-icon btn-danger btn-sm"
          style={{
            minWidth: "50px",
            borderRadius: "12px",
            marginLeft: "5px",
          }}
        >
          <i
            className="flaticon-delete"
            style={{ color: "#FFFFFF", fontSize: "14px" }}
          ></i>
        </Button>
      );
      if (get_pengaturan.t2.statusajuan === 1) {
        p2verify = (
          <>
            <td style={{ textAlign: "center", fontSize: "12px" }}>
              <Badge
                pill
                variant="secondary"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                Belum Terverifikasi
              </Badge>
            </td>
          </>
        );
      } else if (get_pengaturan.t2.statusajuan === 3) {
        p2verify = (
          <>
            <td style={{ textAlign: "center", fontSize: "12px" }}>
              <Badge
                pill
                variant="success"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                <Badge variant="light">
                  {" "}
                  <span style={{ color: "#37bf30" }}>✔</span>
                </Badge>
                &nbsp;&nbsp;&nbsp; Terverifikasi
              </Badge>
            </td>
          </>
        );
      } else {
        p2verify = (
          <>
            <td style={{ textAlign: "center", fontSize: "12x" }}>
              <Badge
                pill
                variant="secondary"
                style={{ backgroundColor: "#CCCCCC", color: "#FFFFFF" }}
              >
                -
              </Badge>
            </td>
          </>
        );
      }
      if (get_pengaturan.t2.dokumen_valid === "0") {
        p2document = (
          <>
            <td
              style={{
                textAlign: "center",
                fontSize: "22px",
                verticalAlign: "top",
              }}
            >
              <Badge
                pill
                variant="warning"
                style={{
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                Belum Valid
              </Badge>
            </td>
          </>
        );
      } else if (get_pengaturan.t2.dokumen_valid === "1") {
        p2document = (
          <>
            <td
              style={{
                textAlign: "center",
                fontSize: "12px",
                verticalAlign: "top",
              }}
            >
              <Badge
                pill
                variant="success"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                Sudah Valid
              </Badge>
            </td>
          </>
        );
      } else {
        p2document = (
          <>
            <td
              style={{
                textAlign: "center",
                fontSize: "12px",
                verticalAlign: "top",
              }}
            >
              <Badge
                pill
                variant="secondary"
                style={{ backgroundColor: "#CCCCCC", color: "#FFFFFF" }}
              >
                Dokumen belum diverifikasi
              </Badge>
            </td>
          </>
        );
      }
      if (get_pengaturan.t2.status === 2) {
        p2status = (
          <>
            {sessiondata.i_idrole === 3 || sessiondata.i_idrole === "3" ? (
              <td style={{ fontSize: "12px" }}>
                <label>
                  <input
                    checked={p2_status === 2}
                    type="radio"
                    name="pengaturanorganisasi"
                    value="dalamunit"
                    onChange={this.handleOrganisasiP2}
                  />
                  &nbsp; Dalam unit tersendiri
                </label>
                <br />
                <label>
                  <input
                    checked={p2_status === 3}
                    type="radio"
                    name="pengaturanorganisasi"
                    value="embedded"
                    onChange={this.handleOrganisasiP2}
                  />
                  &nbsp;
                  <i style={{ fontSize: "12px" }}>Embedded</i> dalam organisasi
                  institusi
                </label>
                <br />
                <label>
                  <input
                    type="radio"
                    name="pengaturanorganisasi"
                    value="kombinasi"
                    checked={p2_status === 4}
                    onChange={this.handleOrganisasiP2}
                  />
                  &nbsp; Kombinasi unit pengelola dan{" "}
                  <i style={{ fontSize: "12px" }}>embedded</i>
                </label>
              </td>
            ) : (
              p2statuslist
            )}

            {p2tautan}
            {p2tanggal}
            {p2tahun}
            {p2verify}
            {p2document}
          </>
        );
        pengaturan_2 = (
          <>
            <tr>
              <td style={{ fontSize: "12px" }}>
                Pengaturan tentang integrasi implementasi SPMI pada Manajemen Perguruan Tinggi
              </td>
              {p2status}
              <td className="text-center pr-0">
                {// SUPER ADMIN
                  sessiondata.i_idrole === 1 ||
                    sessiondata.i_idrole === "1" ||
                    // BELMAWA
                    sessiondata.i_idrole === 10 ||
                    sessiondata.i_idrole === "10" ||
                    // REVIEWER
                    sessiondata.i_idrole === 2013 ||
                    sessiondata.i_idrole === "2013"
                    ? p2aprove
                    : p2aprove}
                {sessiondata.i_idrole === 3 || sessiondata.i_idrole === "3"
                  ? get_pengaturan.t2.statusajuan === 1 || (get_pengaturan.t2.dokumen_valid === "0" || get_pengaturan.t2.dokumen_valid === "null") ? p2edit : ""
                  : ""}
                {p2buttonHistorical}
                {p2buttonInterface}
                {sessiondata.i_idrole === 3 || sessiondata.i_idrole === "3" ? p2delete: ""}
              </td>
            </tr>
          </>
        );
      } else if (get_pengaturan.t2.status === 3) {
        p2status = (
          <>
            {sessiondata.i_idrole === 3 || sessiondata.i_idrole === "3" ? (
              <td style={{ fontSize: "12px" }}>
                <label>
                  <input
                    checked={p2_status === 2}
                    type="radio"
                    name="pengaturanorganisasi"
                    value="dalamunit"
                    onChange={this.handleOrganisasiP2}
                  />
                  &nbsp; Dalam unit tersendiri
                </label>
                <br />
                <label>
                  <input
                    checked={p2_status === 3}
                    type="radio"
                    name="pengaturanorganisasi"
                    value="embedded"
                    onChange={this.handleOrganisasiP2}
                  />
                  &nbsp;
                  <i style={{ fontSize: "12px" }}>Embedded</i> dalam organisasi
                  institusi
                </label>
                <br />
                <label>
                  <input
                    type="radio"
                    name="pengaturanorganisasi"
                    value="kombinasi"
                    checked={p2_status === 4}
                    onChange={this.handleOrganisasiP2}
                  />
                  &nbsp; Kombinasi unit pengelola dan{" "}
                  <i style={{ fontSize: "12px" }}>embedded</i>
                </label>
              </td>
            ) : (
              p2statuslist
            )}
            {p2tautan}
            {p2tanggal}
            {p2tahun}
            {p2verify}
            {p2document}
          </>
        );
        pengaturan_2 = (
          <>
            <tr>
              <td style={{ fontSize: "12px" }}>
                Pengaturan tentang integrasi implementasi SPMI pada Manajemen Perguruan Tinggi
              </td>
              {p2status}
              <td className="text-center pr-0">

                {// SUPER ADMIN
                  sessiondata.i_idrole === 1 ||
                    sessiondata.i_idrole === "1" ||
                    // BELMAWA
                    sessiondata.i_idrole === 10 ||
                    sessiondata.i_idrole === "10" ||
                    // REVIEWER
                    sessiondata.i_idrole === 2013 ||
                    sessiondata.i_idrole === "2013"
                    ? p2aprove
                    : p2aprove}
                {sessiondata.i_idrole === 3 || sessiondata.i_idrole === "3"
                  ? get_pengaturan.t2.statusajuan === 1 ? p2edit : ""
                  : ""}
                {p2buttonHistorical}
                {p2buttonInterface}
              </td>
            </tr>
          </>
        );
      } else if (get_pengaturan.t2.status === 4) {
        p2status = (
          <>
            {sessiondata.i_idrole === 3 || sessiondata.i_idrole === "3" ? (
              <td style={{ fontSize: "12px" }}>
                <label>
                  <input
                    checked={p4_status === 0}
                    type="radio"
                    name="pengaturanorganisasi"
                    value="dalamunit"
                    onChange={this.handleOrganisasiP2}
                  />
                  &nbsp; Dalam unit tersendiri
                </label>
                <br />
                <label>
                  <input
                    checked={p4_status === 1}
                    type="radio"
                    name="pengaturanorganisasi"
                    value="embedded"
                    onChange={this.handleOrganisasiP2}
                  />
                  &nbsp;
                  <i style={{ fontSize: "12px" }}>Embedded</i> dalam organisasi
                  institusi
                </label>
                <br />
                <label>
                  <input
                    type="radio"
                    name="pengaturanorganisasi"
                    value="kombinasi"
                    checked
                    onChange={this.handleOrganisasiP2}
                  />
                  &nbsp; Kombinasi unit pengelola dan{" "}
                  <i style={{ fontSize: "12px" }}>embedded</i>
                </label>
              </td>
            ) : (
              p2statuslist
            )}
            {p2tautan}
            {p2tanggal}
            {p2tahun}
            {p2verify}
            {p2document}
          </>
        );
        pengaturan_2 = (
          <>
            <tr>
              <td style={{ fontSize: "12px" }}>
                Pengaturan tentang integrasi implementasi SPMI pada Manajemen Perguruan Tinggi
              </td>
              {p2status}
              <td className="text-center pr-0">

                {// SUPER ADMIN
                  sessiondata.i_idrole === 1 ||
                    sessiondata.i_idrole === "1" ||
                    // BELMAWA
                    sessiondata.i_idrole === 10 ||
                    sessiondata.i_idrole === "10" ||
                    // REVIEWER
                    sessiondata.i_idrole === 2013 ||
                    sessiondata.i_idrole === "2013"
                    ? p2aprove
                    : p2aprove}
                {sessiondata.i_idrole === 3 || sessiondata.i_idrole === "3"
                  ? get_pengaturan.t2.statusajuan === 1 ? p2edit : ""
                  : ""}
                {p2buttonHistorical}
                {p2buttonInterface}
              </td>
            </tr>
          </>
        );
      }
    } else {
      pengaturan_2 = (
        <>
          <tr>
            <td style={{ fontSize: "12px" }}>
              Pengaturan tentang integrasi implementasi SPMI pada Manajemen Perguruan Tinggi
            </td>
            {sessiondata.i_idrole === 3 || sessiondata.i_idrole === "3" ? (
              <td style={{ fontSize: "12px" }}>
                <label>
                  <input
                    checked={p4_status === 0}
                    type="radio"
                    name="pengaturanorganisasi"
                    value="dalamunit"
                    onChange={this.handleOrganisasiP2}
                  />
                  &nbsp; Dalam unit tersendiri
                </label>
                <br />
                <label>
                  <input
                    checked={p4_status === 1}
                    type="radio"
                    name="pengaturanorganisasi"
                    value="embedded"
                    onChange={this.handleOrganisasiP2}
                  />
                  &nbsp;
                  <i style={{ fontSize: "12px" }}>Embedded</i> dalam organisasi
                  institusi
                </label>
                <br />
                <label>
                  <input
                    type="radio"
                    name="pengaturanorganisasi"
                    value="kombinasi"
                    checked={p4_status === 2}
                    onChange={this.handleOrganisasiP2}
                  />
                  &nbsp; Kombinasi unit pengelola dan{" "}
                  <i style={{ fontSize: "12px" }}>embedded</i>
                </label>
              </td>
            ) : (
              <td style={{ textAlign: "center", fontSize: "12px" }}>-</td>
            )}

            <td colspan="5" style={{ fontSize: "12px" }}>
              Perguruan Tinggi wajib mengisi terkait Ada / Tidak ada Pengaturan
              Kebijakan SPMI
            </td>
            <td className="text-center pr-0">
              {sessiondata.i_idrole === 3 || sessiondata.i_idrole === "3" ? (
                <Button
                  onClick={() => this.handleClickInterface("2")}
                  className="btn btn-icon btn-warning btn-sm"
                  style={{ minWidth: "50px", borderRadius: "12px" }}
                >
                  <i
                    class="flaticon-interface-4"
                    style={{ color: "#ffffff", fontSize: "14px" }}
                  ></i>
                </Button>
              ) : (
                ""
              )}
            </td>
          </tr>
        </>
      );
    }
    // PENGATURAN 3 Pengaturan terkait pelaksanaan standar dalam SPMI Institusi
    if (get_pengaturan.t3) {
      if (get_pengaturan.t3.status === 0) {
        p3statuslist = (
          <>
            <td style={{ textAlign: "center" }}>Tidak Ada</td>
          </>
        );
      } else if (get_pengaturan.t3.status === 1) {
        p3statuslist = (
          <>
            <td style={{ textAlign: "center" }}>Ada</td>
          </>
        );
      } else if (get_pengaturan.t3.status === 2) {
        p3statuslist = (
          <>
            <td style={{ textAlign: "center" }}>Dalam unit tersendiri</td>
          </>
        );
      } else if (get_pengaturan.t3.status === 3) {
        p3statuslist = (
          <>
            <td style={{ textAlign: "center" }}>
              <i>Embedded</i> dalam organisasi institusi
            </td>
          </>
        );
      } else if (get_pengaturan.t3.status === 4) {
        p3statuslist = (
          <>
            <td style={{ textAlign: "center" }}>
              Kombinasi unit pengelola dan <i>embedded</i>
            </td>
          </>
        );
      } else {
        p3statuslist = (
          <>
            <td style={{ textAlign: "center" }}>-</td>
          </>
        );
      }
      p3aprove = (
        <>
          {/* ajuan-pengaturan/detail/ */}
          {/* <td style={{fontSize:'12px'}}>
            <a href={"ajuan-pengaturan/detail/" + get_pengaturan.t3.id_ajuan_pengaturan} className="btn btn-icon btn-primary btn-sm" style={{minWidth: '50px', borderRadius: '12px'}}>
              <i class="flaticon-settings-1" style={{color: '#ffffff', fontSize: '14px'}}></i>
            </a>
          </td> */}
          <td style={{ textAlign: "center", fontSize: "12px", padding: "10px 0px", width: "5%" }}>
            <Link
              to={
                "/ajuan-pengaturan/detail/" +
                get_pengaturan.t3.id_ajuan_pengaturan
              }
            >
              {/* <i class="flaticon-settings-1" style={{color: '#ffffff', fontSize: '14px'}}></i> */}
              <Button
                className="btn btn-icon btn-primary btn-sm"
                style={{ minWidth: "50px", borderRadius: "12px" }}
              >
                <i
                  class="flaticon-eye"
                  style={{ color: "#ffffff", fontSize: "14px" }}
                ></i>
              </Button>
            </Link>
          </td>
        </>
      );
      p3buttonHistorical = (
        <>
          <td style={{ textAlign: "center", fontSize: "12px", padding: "10px 0px", width: "5%" }}>
            <Button
              onClick={() => this.handleShowHistorical(3)}
              className="btn btn-icon btn-success btn-sm"
              style={{ minWidth: "50px", borderRadius: "12px" }}
            >
              <i
                class="flaticon2-time"
                style={{ color: "#ffffff", fontSize: "14px" }}
              ></i>
            </Button>
          </td>
        </>
      );
      let p3buttonInterface = (
        <>
          <td style={{ textAlign: "center", fontSize: "12px", padding: "10px 0px", width: "5%" }}>
            <Button
              onClick={() => this.handleClickInterface(get_pengaturan.t3.id_jenis_aturan)}
              className="btn btn-icon btn-warning btn-sm"
              style={{ minWidth: "50px", borderRadius: "12px" }}
            >
              <i
                class="flaticon-interface-4"
                style={{ color: "#ffffff", fontSize: "14px" }}
              ></i>
            </Button>
          </td>
        </>
      );
      p3tautan = (
        <>
          <td style={{ textAlign: "center", fontSize: "12px" }}>
            <Button
              href={get_pengaturan.t3.tautan}
              target="_blank"
              className="btn btn-icon btn-light btn-sm"
              style={{
                minWidth: "50px",
                borderRadius: "12px",
                background: "#A9C6DE",
              }}
            >
              <i
                class="flaticon-attachment"
                style={{ color: "#3F4254", fontSize: "14px" }}
              ></i>
            </Button>
          </td>
        </>
      );
      p3tanggal = (
        <>
          <td
            style={{
              textAlign: "center",
              fontSize: "12px",
              verticalAlign: "top",
            }}
          >
            <Moment
              date={
                get_pengaturan.t3.tanggal_penetapan
                  ? get_pengaturan.t3.tanggal_penetapan
                  : "loading .."
              }
              format="DD/MM/YYYY"
            />
          </td>
        </>
      );
      p3tahun = (
        <>
          <td
            style={{
              textAlign: "center",
              fontSize: "12px",
              verticalAlign: "top",
            }}
          >
            {get_pengaturan.t3.tahun_siklus
              ? get_pengaturan.t3.tahun_siklus
              : "loading .."}
          </td>
        </>
      );
      if (get_pengaturan.t3.statusajuan === 1) {
        p3verify = (
          <>
            <td
              style={{
                textAlign: "center",
                fontSize: "12px",
                verticalAlign: "top",
              }}
            >
              <Badge
                pill
                variant="secondary"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                Belum Terverifikasi
              </Badge>
            </td>
          </>
        );
      } else if (get_pengaturan.t3.statusajuan === 3) {
        p3verify = (
          <>
            <td
              style={{
                textAlign: "center",
                fontSize: "12px",
                verticalAlign: "top",
              }}
            >
              <Badge
                pill
                variant="success"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                <Badge variant="light">
                  {" "}
                  <span style={{ color: "#37bf30" }}>✔</span>
                </Badge>
                &nbsp;&nbsp;&nbsp; Terverifikasi
              </Badge>
            </td>
          </>
        );
      } else {
        p3verify = (
          <>
            <td
              style={{
                textAlign: "center",
                fontSize: "12px",
                verticalAlign: "top",
              }}
            >
              <Badge
                pill
                variant="secondary"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                -
              </Badge>
            </td>
          </>
        );
      }
      if (get_pengaturan.t3.dokumen_valid === "0") {
        p3document = (
          <>
            <td
              style={{
                textAlign: "center",
                fontSize: "12px",
                verticalAlign: "top",
              }}
            >
              <Badge
                pill
                variant="warning"
                style={{
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                Belum Valid
              </Badge>
            </td>
          </>
        );
      } else if (get_pengaturan.t3.dokumen_valid === "1") {
        p3document = (
          <>
            <td
              style={{
                textAlign: "center",
                fontSize: "12px",
                verticalAlign: "top",
              }}
            >
              <Badge
                pill
                variant="success"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                Sudah Valid
              </Badge>
            </td>
          </>
        );
      } else {
        p3document = (
          <>
            <td
              style={{
                textAlign: "center",
                fontSize: "12px",
                verticalAlign: "top",
              }}
            >
              <Badge
                pill
                variant="secondary"
                style={{ backgroundColor: "#CCCCCC", color: "#FFFFFF" }}
              >
                Dokumen belum diverifikasi
              </Badge>
            </td>
          </>
        );
      }
      p3keterangan = (
        <>
          <td style={{ textAlign: "center", fontSize: "12px" }}>
            {this.state.get_pengaturan.t3.keterangan
              ? this.state.get_pengaturan.t3.keterangan
              : "loading.."}
          </td>
        </>
      );
      p3edit = (
        <>
          <td style={{ textAlign: "center", fontSize: "12px" }}>
            <Button
              onClick={this.handleEditButtonP3}
              className="btn btn-icon btn-primary btn-sm"
              style={{ minWidth: "50px", borderRadius: "12px" }}
            >
              <i
                class="flaticon-edit"
                style={{ color: "#ffffff", fontSize: "14px" }}
              ></i>
            </Button>
          </td>
        </>
      );
      if (get_pengaturan.t3.status === 1) {
        p3status = (
          <>
            {sessiondata.i_idrole === 3 || sessiondata.i_idrole === "3" ? (
              <td style={{ fontSize: "12px" }}>
                <span>
                  <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                    <input
                      checked={p3_status === 1}
                      type="radio"
                      name="pelaksanaan"
                      value="ada"
                    />
                    &nbsp; Ada
                  </label>
                </span>
                &nbsp;&nbsp;
                <span>
                  <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                    <input
                      checked={p3_status === 0}
                      type="radio"
                      name="pelaksanaan"
                      value="tidakada"
                      onChange={this.handleEditTidakAdaP3}
                    />
                    &nbsp; Tidak ada
                  </label>
                </span>
              </td>
            ) : (
              p3statuslist
            )}
            {p3tautan}
            {p3tanggal}
            {p3tahun}
            {p3verify}
            {p3document}
            {sessiondata.i_idrole === 3 || sessiondata.i_idrole === "3"
              ? p3edit
              : ""}
            {// SUPER ADMIN
              sessiondata.i_idrole === 1 ||
                sessiondata.i_idrole === "1" ||
                // BELMAWA
                sessiondata.i_idrole === 10 ||
                sessiondata.i_idrole === "10" ||
                // REVIEWER
                sessiondata.i_idrole === 2013 ||
                sessiondata.i_idrole === "2013"
                ? p3aprove
                : p3aprove}
          </>
        );
        pengaturan_3 = (
          <>
            <tr>
              <td style={{ fontSize: "12px", verticalAlign: "middle" }}>
                Pengaturan terkait pelaksanaan standar dalam SPMI Institusi
              </td>
              {p3status}
              {p3buttonHistorical}
              {p3buttonInterface}
            </tr>
          </>
        );
      } else if (get_pengaturan.t3.status === 0) {
        p3status = (
          <>
            <td style={{ fontSize: "12px" }}>
              <span>
                <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                  <input
                    type="radio"
                    checked={p3_status === 1}
                    name="pelaksanaan"
                    value="ada"
                    onChange={this.handleEditButtonP3}
                  />
                  &nbsp; Ada
                </label>
              </span>
              &nbsp;&nbsp;
              <span>
                <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                  <input
                    checked
                    type="radio"
                    name="pelaksanaan"
                    value="tidakada"
                    onChange={this.handleEditButtonP3}
                  />
                  &nbsp; Tidak ada
                </label>
              </span>
            </td>
            {p3keterangan}
            {p3tanggal}
            {p3tahun}
            {p3verify}
          </>
        );
        pengaturan_3 = (
          <>
            <tr>
              <td style={{ fontSize: "12px" }}>
                Pengaturan terkait pelaksanaan standar dalam SPMI Institusi
              </td>
              {p3status}
              {p3buttonHistorical}
              {p3buttonInterface}
            </tr>
          </>
        );
      }
    } else {
      pengaturan_3 = (
        <>
          <tr>
            <td style={{ fontSize: "12px" }}>
              Pengaturan terkait pelaksanaan standar dalam SPMI Institusi
            </td>
            {sessiondata.i_idrole === 3 || sessiondata.i_idrole === "3" ? (
              <td style={{ fontSize: "12px" }}>
                <span>
                  <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                    <input
                      type="radio"
                      checked={p3_status === 1}
                      name="pelaksanaan"
                      value="ada"
                      onChange={this.handleShowP3}
                    />
                    &nbsp; Ada
                  </label>
                </span>
                &nbsp;&nbsp;
                <span>
                  <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                    <input
                      checked={p3_status === 0}
                      type="radio"
                      name="pelaksanaan"
                      value="tidakada"
                      onChange={this.handleShowP3}
                    />
                    &nbsp; Tidak ada
                  </label>
                </span>
              </td>
            ) : (
              <td style={{ textAlign: "center", fontSize: "12px" }}>-</td>
            )}

            <td colspan="5" style={{ fontSize: "12px" }}>
              Perguruan Tinggi wajib mengisi terkait Ada / Tidak ada Pengaturan
              Kebijakan SPMI
            </td>
          </tr>
        </>
      );
    }
    // PENGATURAN 4 Pengaturan terkait evaluasi pelaksanaan standar
    if (get_pengaturan.t4) {
      if (get_pengaturan.t4.status === 0) {
        p4statuslist = (
          <>
            <td style={{ textAlign: "center", fontSize: "12px" }}>Tidak Ada</td>
          </>
        );
      } else if (get_pengaturan.t4.status === 1) {
        p4statuslist = (
          <>
            <td style={{ textAlign: "center", fontSize: "12px" }}>Ada</td>
          </>
        );
      } else if (get_pengaturan.t4.status === 2) {
        p4statuslist = (
          <>
            <td style={{ textAlign: "center", fontSize: "12px" }}>
              Dalam unit tersendiri
            </td>
          </>
        );
      } else if (get_pengaturan.t4.status === 3) {
        p4statuslist = (
          <>
            <td style={{ textAlign: "center", fontSize: "12px" }}>
              <i>Embedded</i> dalam organisasi institusi
            </td>
          </>
        );
      } else if (get_pengaturan.t4.status === 4) {
        p4statuslist = (
          <>
            <td style={{ textAlign: "center", fontSize: "12px" }}>
              Kombinasi unit pengelola dan <i>embedded</i>
            </td>
          </>
        );
      } else {
        p4statuslist = (
          <>
            <td style={{ textAlign: "center", fontSize: "12px" }}>-</td>
          </>
        );
      }
      p4aprove = (
        <>
          {/* ajuan-pengaturan/detail/ */}
          {/* <td style={{fontSize:'12px'}}>
            <a href={"ajuan-pengaturan/detail/" + get_pengaturan.t4.id_ajuan_pengaturan} className="btn btn-icon btn-primary btn-sm" style={{minWidth: '50px', borderRadius: '12px'}}>
              <i class="flaticon-settings-1" style={{color: '#ffffff', fontSize: '14px'}}></i>
            </a>
          </td> */}
          <td style={{ textAlign: "center", fontSize: "12px", padding: "10px 0px", width: "5%" }}>
            <Link
              to={
                "/ajuan-pengaturan/detail/" +
                get_pengaturan.t4.id_ajuan_pengaturan
              }
            >
              {/* <i class="flaticon-settings-1" style={{color: '#ffffff', fontSize: '14px'}}></i> */}
              <Button
                className="btn btn-icon btn-primary btn-sm"
                style={{ minWidth: "50px", borderRadius: "12px" }}
              >
                <i
                  class="flaticon-eye"
                  style={{ color: "#ffffff", fontSize: "14px" }}
                ></i>
              </Button>
            </Link>
          </td>
        </>
      );
      p4tautan = (
        <>
          <td style={{ textAlign: "center", fontSize: "12px" }}>
            <Button
              href={get_pengaturan.t4.tautan}
              target="_blank"
              className="btn btn-icon btn-light btn-sm"
              style={{
                minWidth: "50px",
                borderRadius: "12px",
                background: "#A9C6DE",
              }}
            >
              <i
                class="flaticon-attachment"
                style={{ color: "#3F4254", fontSize: "14px" }}
              ></i>
            </Button>
          </td>
        </>
      );
      p4buttonHistorical = (
        <>
          <td style={{ textAlign: "center", fontSize: "12px", padding: "10px 0px", width: "5%" }}>
            <Button
              onClick={() => this.handleShowHistorical(4)}
              className="btn btn-icon btn-success btn-sm"
              style={{ minWidth: "50px", borderRadius: "12px" }}
            >
              <i
                class="flaticon2-time"
                style={{ color: "#ffffff", fontSize: "14px" }}
              ></i>
            </Button>
          </td>
        </>
      );
      let p4buttonInterface = (
        <>
          <td style={{ textAlign: "center", fontSize: "12px", padding: "10px 0px", width: "5%" }}>
            <Button
              onClick={() => this.handleClickInterface(get_pengaturan.t4.id_jenis_aturan)}
              className="btn btn-icon btn-warning btn-sm"
              style={{ minWidth: "50px", borderRadius: "12px" }}
            >
              <i
                class="flaticon-interface-4"
                style={{ color: "#ffffff", fontSize: "14px" }}
              ></i>
            </Button>
          </td>
        </>
      );
      p4tanggal = (
        <>
          <td
            style={{
              textAlign: "center",
              fontSize: "12px",
              verticalAlign: "top",
            }}
          >
            <Moment
              date={
                get_pengaturan.t4.tanggal_penetapan
                  ? get_pengaturan.t4.tanggal_penetapan
                  : "loading .."
              }
              format="DD/MM/YYYY"
            />
          </td>
        </>
      );
      p4tahun = (
        <>
          <td
            style={{
              textAlign: "center",
              fontSize: "12px",
              verticalAlign: "top",
            }}
          >
            {get_pengaturan.t4.tahun_siklus
              ? get_pengaturan.t4.tahun_siklus
              : "loading .."}
          </td>
        </>
      );
      if (get_pengaturan.t4.statusajuan === 1) {
        p4verify = (
          <>
            <td
              style={{
                textAlign: "center",
                fontSize: "12px",
                verticalAlign: "top",
              }}
            >
              <Badge
                pill
                variant="secondary"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                Belum Terverifikasi
              </Badge>
            </td>
          </>
        );
      } else if (get_pengaturan.t4.statusajuan === 3) {
        p4verify = (
          <>
            <td
              style={{
                textAlign: "center",
                fontSize: "12px",
                verticalAlign: "top",
              }}
            >
              <Badge
                pill
                variant="success"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                <Badge variant="light">
                  {" "}
                  <span style={{ color: "#37bf30" }}>✔</span>
                </Badge>
                &nbsp;&nbsp;&nbsp; Terverifikasi
              </Badge>
            </td>
          </>
        );
      } else {
        p4verify = (
          <>
            <td
              style={{
                textAlign: "center",
                fontSize: "12px",
                verticalAlign: "top",
              }}
            >
              <Badge
                pill
                variant="secondary"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                -
              </Badge>
            </td>
          </>
        );
      }
      if (get_pengaturan.t4.dokumen_valid === "0") {
        p4document = (
          <>
            <td
              style={{
                textAlign: "center",
                fontSize: "12px",
                verticalAlign: "top",
              }}
            >
              <Badge
                pill
                variant="warning"
                style={{
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                Belum Valid
              </Badge>
            </td>
          </>
        );
      } else if (get_pengaturan.t4.dokumen_valid === "1") {
        p4document = (
          <>
            <td
              style={{
                textAlign: "center",
                fontSize: "12px",
                verticalAlign: "top",
              }}
            >
              <Badge
                pill
                variant="success"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                Sudah Valid
              </Badge>
            </td>
          </>
        );
      } else {
        p4document = (
          <>
            <td
              style={{
                textAlign: "center",
                fontSize: "12px",
                verticalAlign: "top",
              }}
            >
              <Badge
                pill
                variant="secondary"
                style={{ backgroundColor: "#CCCCCC", color: "#FFFFFF" }}
              >
                Dokumen belum diverifikasi
              </Badge>
            </td>
          </>
        );
      }
      p4keterangan = (
        <>
          <td style={{ textAlign: "center", fontSize: "12px" }}>
            {this.state.get_pengaturan.t4.keterangan
              ? this.state.get_pengaturan.t4.keterangan
              : "loading.."}
          </td>
        </>
      );
      p4edit = (
        <>
          <td style={{ textAlign: "center", fontSize: "12px" }}>
            <Button
              onClick={this.handleEditButtonP4}
              className="btn btn-icon btn-primary btn-sm"
              style={{ minWidth: "50px", borderRadius: "12px" }}
            >
              <i
                class="flaticon-edit"
                style={{ color: "#ffffff", fontSize: "14px" }}
              ></i>
            </Button>
          </td>
        </>
      );
      if (get_pengaturan.t4.status === 1) {
        p4status = (
          <>
            {sessiondata.i_idrole === 3 || sessiondata.i_idrole === "3" ? (
              <td style={{ fontSize: "12px" }}>
                <span>
                  <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                    <input
                      checked={p4_status === 1}
                      type="radio"
                      name="evaluasi"
                      value="ada"
                    />
                    &nbsp; Ada
                  </label>
                </span>
                &nbsp;&nbsp;
                <span>
                  <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                    <input
                      checked={p4_status === 0}
                      type="radio"
                      name="evaluasi"
                      value="tidakada"
                      onChange={this.handleEditTidakAdaP4}
                    />
                    &nbsp; Tidak ada
                  </label>
                </span>
              </td>
            ) : (
              p4statuslist
            )}

            {p4tautan}
            {p4tanggal}
            {p4tahun}
            {p4verify}
            {p4document}
            {sessiondata.i_idrole === 3 || sessiondata.i_idrole === "3"
              ? p4edit
              : ""}
            {// SUPER ADMIN
              sessiondata.i_idrole === 1 ||
                sessiondata.i_idrole === "1" ||
                // BELMAWA
                sessiondata.i_idrole === 10 ||
                sessiondata.i_idrole === "10" ||
                // REVIEWER
                sessiondata.i_idrole === 2013 ||
                sessiondata.i_idrole === "2013"
                ? p4aprove
                : p4aprove}
          </>
        );
        pengaturan_4 = (
          <>
            <tr>
              <td style={{ fontSize: "12px" }}>
                Pengaturan terkait evaluasi pelaksanaan standar
              </td>
              {p4status}
              {p4buttonHistorical}
              {p4buttonInterface}
            </tr>
          </>
        );
      } else if (get_pengaturan.t4.status === 0) {
        p4status = (
          <>
            <td style={{ fontSize: "12px" }}>
              <span>
                <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                  <input
                    type="radio"
                    checked={p4_status === 1}
                    name="evaluasi"
                    value="ada"
                    onChange={this.handleEditButtonP4}
                  />
                  &nbsp; Ada
                </label>
              </span>
              &nbsp;&nbsp;
              <span>
                <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                  <input
                    checked
                    type="radio"
                    name="evaluasi"
                    value="tidakada"
                    onChange={this.handleEditButtonP4}
                  />
                  &nbsp; Tidak ada
                </label>
              </span>
            </td>
            {p4keterangan}
            {p4tanggal}
            {p4tahun}
            {p4verify}
          </>
        );
        pengaturan_4 = (
          <>
            <tr>
              <td style={{ fontSize: "12px" }}>
                Pengaturan terkait evaluasi pelaksanaan standar
              </td>
              {p4status}
              {p4buttonHistorical}
              {p4buttonInterface}
            </tr>
          </>
        );
      }
    } else {
      pengaturan_4 = (
        <>
          <tr>
            <td style={{ fontSize: "12px" }}>
              Pengaturan terkait evaluasi pelaksanaan standar
            </td>
            {sessiondata.i_idrole === 3 || sessiondata.i_idrole === "3" ? (
              <td style={{ fontSize: "12px" }}>
                <span>
                  <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                    <input
                      type="radio"
                      checked={p4_status === 1}
                      name="evaluasi"
                      value="ada"
                      onChange={this.handleShowP4}
                    />
                    &nbsp; Ada
                  </label>
                </span>
                &nbsp;&nbsp;
                <span>
                  <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                    <input
                      checked={p4_status === 0}
                      type="radio"
                      name="evaluasi"
                      value="tidakada"
                      onChange={this.handleShowP4}
                    />
                    &nbsp; Tidak ada
                  </label>
                </span>
              </td>
            ) : (
              <td style={{ textAlign: "center", fontSize: "12px" }}>-</td>
            )}

            <td colspan="5" style={{ fontSize: "12px" }}>
              Perguruan Tinggi wajib mengisi terkait Ada / Tidak ada Pengaturan
              Kebijakan SPMI
            </td>
          </tr>
        </>
      );
    }
    // PENGATURAN 5 Pengaturan terkait pengendalian pelaksanaan standar
    if (get_pengaturan.t5) {
      if (get_pengaturan.t5.status === 0) {
        p5statuslist = (
          <>
            <td style={{ textAlign: "center", fontSize: "12px" }}>Tidak Ada</td>
          </>
        );
      } else if (get_pengaturan.t5.status === 1) {
        p5statuslist = (
          <>
            <td style={{ textAlign: "center", fontSize: "12px" }}>Ada</td>
          </>
        );
      } else if (get_pengaturan.t5.status === 2) {
        p5statuslist = (
          <>
            <td style={{ textAlign: "center", fontSize: "12px" }}>
              Dalam unit tersendiri
            </td>
          </>
        );
      } else if (get_pengaturan.t5.status === 3) {
        p5statuslist = (
          <>
            <td style={{ textAlign: "center", fontSize: "12px" }}>
              <i>Embedded</i> dalam organisasi institusi
            </td>
          </>
        );
      } else if (get_pengaturan.t5.status === 4) {
        p5statuslist = (
          <>
            <td style={{ textAlign: "center", fontSize: "12px" }}>
              Kombinasi unit pengelola dan <i>embedded</i>
            </td>
          </>
        );
      } else {
        p5statuslist = (
          <>
            <td style={{ textAlign: "center", fontSize: "12px" }}>-</td>
          </>
        );
      }
      p5aprove = (
        <>
          {/* ajuan-pengaturan/detail/ */}
          {/* <td style={{fontSize:'12px'}}>
            <a href={"ajuan-pengaturan/detail/" + get_pengaturan.t5.id_ajuan_pengaturan} className="btn btn-icon btn-primary btn-sm" style={{minWidth: '50px', borderRadius: '12px'}}>
              <i class="flaticon-settings-1" style={{color: '#ffffff', fontSize: '14px'}}></i>
            </a>
          </td> */}
          <td style={{ textAlign: "center", fontSize: "12px", padding: "10px 0px", width: "5%" }}>
            <Link
              to={
                "/ajuan-pengaturan/detail/" +
                get_pengaturan.t5.id_ajuan_pengaturan
              }
            >
              {/* <i class="flaticon-settings-1" style={{color: '#ffffff', fontSize: '14px'}}></i> */}
              <Button
                className="btn btn-icon btn-primary btn-sm"
                style={{ minWidth: "50px", borderRadius: "12px" }}
              >
                <i
                  class="flaticon-eye"
                  style={{ color: "#ffffff", fontSize: "14px" }}
                ></i>
              </Button>
            </Link>
          </td>
        </>
      );
      p5tautan = (
        <>
          <td style={{ textAlign: "center", fontSize: "12px" }}>
            <Button
              href={get_pengaturan.t5.tautan}
              target="_blank"
              className="btn btn-icon btn-light btn-sm"
              style={{
                minWidth: "50px",
                borderRadius: "12px",
                background: "#A9C6DE",
              }}
            >
              <i
                class="flaticon-attachment"
                style={{ color: "#3F4254", fontSize: "14px" }}
              ></i>
            </Button>
          </td>
        </>
      );
      p5buttonHistorical = (
        <>
          <td style={{ textAlign: "center", fontSize: "12px", padding: "10px 0px", width: "5%" }}>
            <Button
              onClick={() => this.handleShowHistorical(5)}
              className="btn btn-icon btn-success btn-sm"
              style={{ minWidth: "50px", borderRadius: "12px" }}
            >
              <i
                class="flaticon2-time"
                style={{ color: "#ffffff", fontSize: "14px" }}
              ></i>
            </Button>
          </td>
        </>
      );
      let p5buttonInterface = (
        <>
          <td style={{ textAlign: "center", fontSize: "12px", padding: "10px 0px", width: "5%" }}>
            <Button
              onClick={() => this.handleClickInterface(get_pengaturan.t5.id_jenis_aturan)}
              className="btn btn-icon btn-warning btn-sm"
              style={{ minWidth: "50px", borderRadius: "12px" }}
            >
              <i
                class="flaticon-interface-4"
                style={{ color: "#ffffff", fontSize: "14px" }}
              ></i>
            </Button>
          </td>
        </>
      );
      p5tanggal = (
        <>
          <td
            style={{
              textAlign: "center",
              fontSize: "12px",
              verticalAlign: "top",
            }}
          >
            <Moment
              date={
                get_pengaturan.t5.tanggal_penetapan
                  ? get_pengaturan.t5.tanggal_penetapan
                  : "loading .."
              }
              format="DD/MM/YYYY"
            />
          </td>
        </>
      );
      p5tahun = (
        <>
          <td
            style={{
              textAlign: "center",
              fontSize: "12px",
              verticalAlign: "top",
            }}
          >
            {get_pengaturan.t5.tahun_siklus
              ? get_pengaturan.t5.tahun_siklus
              : "loading .."}
          </td>
        </>
      );
      if (get_pengaturan.t5.statusajuan === 1) {
        p5verify = (
          <>
            <td
              style={{
                textAlign: "center",
                fontSize: "12px",
                verticalAlign: "top",
              }}
            >
              <Badge
                pill
                variant="secondary"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                Belum Terverifikasi
              </Badge>
            </td>
          </>
        );
      } else if (get_pengaturan.t5.statusajuan === 3) {
        p5verify = (
          <>
            <td
              style={{
                textAlign: "center",
                fontSize: "12px",
                verticalAlign: "top",
              }}
            >
              <Badge
                pill
                variant="success"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                <Badge variant="light">
                  {" "}
                  <span style={{ color: "#37bf30" }}>✔</span>
                </Badge>
                &nbsp;&nbsp;&nbsp; Terverifikasi
              </Badge>
            </td>
          </>
        );
      } else {
        p5verify = (
          <>
            <td
              style={{
                textAlign: "center",
                fontSize: "12px",
                verticalAlign: "top",
              }}
            >
              <Badge
                pill
                variant="secondary"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                -
              </Badge>
            </td>
          </>
        );
      }
      if (get_pengaturan.t5.dokumen_valid === "0") {
        p5document = (
          <>
            <td
              style={{
                textAlign: "center",
                fontSize: "12px",
                verticalAlign: "top",
              }}
            >
              <Badge
                pill
                variant="warning"
                style={{
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                Belum Valid
              </Badge>
            </td>
          </>
        );
      } else if (get_pengaturan.t5.dokumen_valid === "1") {
        p5document = (
          <>
            <td
              style={{
                textAlign: "center",
                fontSize: "12px",
                verticalAlign: "top",
              }}
            >
              <Badge
                pill
                variant="success"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                Sudah Valid
              </Badge>
            </td>
          </>
        );
      } else {
        p5document = (
          <>
            <td
              style={{
                textAlign: "center",
                fontSize: "12px",
                verticalAlign: "top",
              }}
            >
              <Badge
                pill
                variant="secondary"
                style={{ backgroundColor: "#CCCCCC", color: "#FFFFFF" }}
              >
                Dokumen belum diverifikasi
              </Badge>
            </td>
          </>
        );
      }
      p5keterangan = (
        <>
          <td style={{ textAlign: "center", fontSize: "12px" }}>
            {this.state.get_pengaturan.t5.keterangan
              ? this.state.get_pengaturan.t5.keterangan
              : "loading.."}
          </td>
        </>
      );
      p5edit = (
        <>
          <td style={{ textAlign: "center", fontSize: "12px" }}>
            <Button
              onClick={this.handleEditButtonP5}
              className="btn btn-icon btn-primary btn-sm"
              style={{ minWidth: "50px", borderRadius: "12px" }}
            >
              <i
                class="flaticon-edit"
                style={{ color: "#ffffff", fontSize: "14px" }}
              ></i>
            </Button>
          </td>
        </>
      );
      if (get_pengaturan.t5.status === 1) {
        p5status = (
          <>
            {sessiondata.i_idrole === 3 || sessiondata.i_idrole === "3" ? (
              <td style={{ fontSize: "12px" }}>
                <span>
                  <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                    <input
                      checked={p5_status === 1}
                      type="radio"
                      name="pengendalian"
                      value="ada"
                    />
                    &nbsp; Ada
                  </label>
                </span>
                &nbsp;&nbsp;
                <span>
                  <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                    <input
                      checked={p5_status === 0}
                      type="radio"
                      name="pengendalian"
                      value="tidakada"
                      onChange={this.handleEditTidakAdaP5}
                    />
                    &nbsp; Tidak ada
                  </label>
                </span>
              </td>
            ) : (
              p5statuslist
            )}

            {p5tautan}
            {p5tanggal}
            {p5tahun}
            {p5verify}
            {p5document}
            {sessiondata.i_idrole === 3 || sessiondata.i_idrole === "3"
              ? p5edit
              : ""}
            {// SUPER ADMIN
              sessiondata.i_idrole === 1 ||
                sessiondata.i_idrole === "1" ||
                // BELMAWA
                sessiondata.i_idrole === 10 ||
                sessiondata.i_idrole === "10" ||
                // REVIEWER
                sessiondata.i_idrole === 2013 ||
                sessiondata.i_idrole === "2013"
                ? p5aprove
                : p5aprove}
          </>
        );
        pengaturan_5 = (
          <>
            <tr>
              <td style={{ fontSize: "12px" }}>
                Pengaturan terkait pengendalian pelaksanaan standar
              </td>
              {p5status}
              {p5buttonHistorical}
              {p5buttonInterface}
            </tr>
          </>
        );
      } else if (get_pengaturan.t5.status === 0) {
        p5status = (
          <>
            <td style={{ fontSize: "12px" }}>
              <span>
                <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                  <input
                    type="radio"
                    checked={p5_status === 1}
                    name="pengendalian"
                    value="ada"
                    onChange={this.handleEditButtonP5}
                  />
                  &nbsp; Ada
                </label>
              </span>
              &nbsp;&nbsp;
              <span>
                <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                  <input
                    checked
                    type="radio"
                    name="pengendalian"
                    value="tidakada"
                    onChange={this.handleEditButtonP5}
                  />
                  &nbsp; Tidak ada
                </label>
              </span>
            </td>
            {p5keterangan}
            {p5tanggal}
            {p5tahun}
            {p5verify}
          </>
        );
        pengaturan_5 = (
          <>
            <tr>
              <td style={{ fontSize: "12px" }}>
                Pengaturan terkait pengendalian pelaksanaan standar
              </td>
              {p5status}
              {p5buttonHistorical}
              {p5buttonInterface}
            </tr>
          </>
        );
      }
    } else {
      pengaturan_5 = (
        <>
          <tr>
            <td style={{ fontSize: "12px" }}>
              Pengaturan terkait pengendalian pelaksanaan standar
            </td>
            {sessiondata.i_idrole === 3 || sessiondata.i_idrole === "3" ? (
              <td style={{ fontSize: "12px" }}>
                <span>
                  <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                    <input
                      type="radio"
                      checked={p5_status === 1}
                      name="pengendalian"
                      value="ada"
                      onChange={this.handleShowP5}
                    />
                    &nbsp; Ada
                  </label>
                </span>
                &nbsp;&nbsp;
                <span>
                  <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                    <input
                      checked={p5_status === 0}
                      type="radio"
                      name="pengendalian"
                      value="tidakada"
                      onChange={this.handleShowP5}
                    />
                    &nbsp; Tidak ada
                  </label>
                </span>
              </td>
            ) : (
              <td style={{ textAlign: "center", fontSize: "12px" }}>-</td>
            )}

            <td colspan="5" style={{ fontSize: "12px" }}>
              Perguruan Tinggi wajib mengisi terkait Ada / Tidak ada Pengaturan
              Kebijakan SPMI
            </td>
          </tr>
        </>
      );
    }
    // PENGATURAN 6 Pengaturan terkait peningkatan standar dalam SPMI Institusi
    if (get_pengaturan.t6) {
      if (get_pengaturan.t6.status === 0) {
        p6statuslist = (
          <>
            <td style={{ textAlign: "center", fontSize: "12px" }}>Tidak Ada</td>
          </>
        );
      } else if (get_pengaturan.t6.status === 1) {
        p6statuslist = (
          <>
            <td style={{ textAlign: "center", fontSize: "12px" }}>Ada</td>
          </>
        );
      } else if (get_pengaturan.t6.status === 2) {
        p6statuslist = (
          <>
            <td style={{ textAlign: "center", fontSize: "12px" }}>
              Dalam unit tersendiri
            </td>
          </>
        );
      } else if (get_pengaturan.t6.status === 3) {
        p6statuslist = (
          <>
            <td style={{ textAlign: "center", fontSize: "12px" }}>
              <i>Embedded</i> dalam organisasi institusi
            </td>
          </>
        );
      } else if (get_pengaturan.t6.status === 4) {
        p6statuslist = (
          <>
            <td style={{ textAlign: "center", fontSize: "12px" }}>
              Kombinasi unit pengelola dan <i>embedded</i>
            </td>
          </>
        );
      } else {
        p6statuslist = (
          <>
            <td style={{ textAlign: "center", fontSize: "12px" }}>-</td>
          </>
        );
      }
      p6aprove = (
        <>
          {/* ajuan-pengaturan/detail/ */}
          {/* <td>
            <a href={"ajuan-pengaturan/detail/" + get_pengaturan.t6.id_ajuan_pengaturan} className="btn btn-icon btn-primary btn-sm" style={{minWidth: '50px', borderRadius: '12px'}}>
              <i class="flaticon-settings-1" style={{color: '#ffffff', fontSize: '14px'}}></i>
            </a>
          </td> */}
          <td style={{ textAlign: "center", fontSize: "12px", padding: "10px 0px", width: "5%" }}>
            <Link
              to={
                "/ajuan-pengaturan/detail/" +
                get_pengaturan.t6.id_ajuan_pengaturan
              }
            >
              {/* <i class="flaticon-settings-1" style={{color: '#ffffff', fontSize: '14px'}}></i> */}
              <Button
                className="btn btn-icon btn-primary btn-sm"
                style={{ minWidth: "50px", borderRadius: "12px" }}
              >
                <i
                  class="flaticon-eye"
                  style={{ color: "#ffffff", fontSize: "14px" }}
                ></i>
              </Button>
            </Link>
          </td>
        </>
      );
      p6tautan = (
        <>
          <td style={{ textAlign: "center", fontSize: "12px" }}>
            <Button
              href={get_pengaturan.t6.tautan}
              target="_blank"
              className="btn btn-icon btn-light btn-sm"
              style={{
                minWidth: "50px",
                borderRadius: "12px",
                background: "#A9C6DE",
              }}
            >
              <i
                class="flaticon-attachment"
                style={{ color: "#3F4254", fontSize: "14px" }}
              ></i>
            </Button>
          </td>
        </>
      );
      p6buttonHistorical = (
        <>
          <td style={{ textAlign: "center", fontSize: "12px", padding: "10px 0px", width: "5%" }}>
            <Button
              onClick={() => this.handleShowHistorical(6)}
              className="btn btn-icon btn-success btn-sm"
              style={{ minWidth: "50px", borderRadius: "12px" }}
            >
              <i
                class="flaticon2-time"
                style={{ color: "#ffffff", fontSize: "14px" }}
              ></i>
            </Button>
          </td>
        </>
      );
      let p6buttonInterface = (
        <>
          <td style={{ textAlign: "center", fontSize: "12px", padding: "10px 0px", width: "5%" }}>
            <Button
              onClick={() => this.handleClickInterface(get_pengaturan.t6.id_jenis_aturan)}
              className="btn btn-icon btn-warning btn-sm"
              style={{ minWidth: "50px", borderRadius: "12px" }}
            >
              <i
                class="flaticon-interface-4"
                style={{ color: "#ffffff", fontSize: "14px" }}
              ></i>
            </Button>
          </td>
        </>
      );
      p6tanggal = (
        <>
          <td
            style={{
              textAlign: "center",
              fontSize: "12px",
              verticalAlign: "top",
            }}
          >
            <Moment
              date={
                get_pengaturan.t6.tanggal_penetapan
                  ? get_pengaturan.t6.tanggal_penetapan
                  : "loading .."
              }
              format="DD/MM/YYYY"
            />
          </td>
        </>
      );
      p6tahun = (
        <>
          <td
            style={{
              textAlign: "center",
              fontSize: "12px",
              verticalAlign: "top",
            }}
          >
            {get_pengaturan.t6.tahun_siklus
              ? get_pengaturan.t6.tahun_siklus
              : "loading .."}
          </td>
        </>
      );

      if (get_pengaturan.t6.statusajuan === 1) {
        p6verify = (
          <>
            <td
              style={{
                textAlign: "center",
                fontSize: "12px",
                verticalAlign: "top",
              }}
            >
              <Badge
                pill
                variant="secondary"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                Belum Terverifikasi
              </Badge>
            </td>
          </>
        );
      } else if (get_pengaturan.t6.statusajuan === 3) {
        p6verify = (
          <>
            <td
              style={{
                textAlign: "center",
                fontSize: "12px",
                verticalAlign: "top",
              }}
            >
              <Badge
                pill
                variant="success"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                <Badge variant="light">
                  {" "}
                  <span style={{ color: "#37bf30" }}>✔</span>
                </Badge>
                &nbsp;&nbsp;&nbsp; Terverifikasi
              </Badge>
            </td>
          </>
        );
      } else {
        p6verify = (
          <>
            <td
              style={{
                textAlign: "center",
                fontSize: "12px",
                verticalAlign: "top",
              }}
            >
              <Badge
                pill
                variant="secondary"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                -
              </Badge>
            </td>
          </>
        );
      }
      if (get_pengaturan.t6.dokumen_valid === "0") {
        p6document = (
          <>
            <td
              style={{
                textAlign: "center",
                fontSize: "12px",
                verticalAlign: "top",
              }}
            >
              <Badge
                pill
                variant="warning"
                style={{
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                Belum Valid
              </Badge>
            </td>
          </>
        );
      } else if (get_pengaturan.t6.dokumen_valid === "1") {
        p6document = (
          <>
            <td
              style={{
                textAlign: "center",
                fontSize: "12px",
                verticalAlign: "top",
              }}
            >
              <Badge
                pill
                variant="success"
                style={{
                  backgroundColor: "#BEF2FF",
                  color: "#334443",
                  fontSize: "12px",
                }}
              >
                Sudah Valid
              </Badge>
            </td>
          </>
        );
      } else {
        p6document = (
          <>
            <td
              style={{
                textAlign: "center",
                fontSize: "12px",
                verticalAlign: "top",
              }}
            >
              <Badge
                pill
                variant="secondary"
                style={{ backgroundColor: "#CCCCCC", color: "#FFFFFF" }}
              >
                Dokumen belum diverifikasi
              </Badge>
            </td>
          </>
        );
      }
      p6keterangan = (
        <>
          <td style={{ textAlign: "center", fontSize: "12px" }}>
            {this.state.get_pengaturan.t6.keterangan
              ? this.state.get_pengaturan.t6.keterangan
              : "loading.."}
          </td>
        </>
      );
      p6edit = (
        <>
          <td style={{ textAlign: "center", fontSize: "12px" }}>
            <Button
              onClick={this.handleEditButtonP6}
              className="btn btn-icon btn-primary btn-sm"
              style={{ minWidth: "50px", borderRadius: "12px" }}
            >
              <i
                class="flaticon-edit"
                style={{ color: "#ffffff", fontSize: "14px" }}
              ></i>
            </Button>
          </td>
        </>
      );
      if (get_pengaturan.t6.status === 1) {
        p6status = (
          <>
            {sessiondata.i_idrole === 3 || sessiondata.i_idrole === "3" ? (
              <td style={{ fontSize: "12px" }}>
                <span>
                  <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                    <input
                      checked={p6_status === 1}
                      type="radio"
                      name="peningkatan"
                      value="ada"
                    />
                    &nbsp; Ada
                  </label>
                </span>
                &nbsp;&nbsp;
                <span>
                  <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                    <input
                      checked={p6_status === 0}
                      type="radio"
                      name="peningkatan"
                      value="tidakada"
                      onChange={this.handleEditTidakAdaP6}
                    />
                    &nbsp; Tidak ada
                  </label>
                </span>
              </td>
            ) : (
              p6statuslist
            )}
            {p6tautan}
            {p6tanggal}
            {p6tahun}
            {p6verify}
            {p6document}
            {sessiondata.i_idrole === 3 || sessiondata.i_idrole === "3"
              ? p6edit
              : ""}
            {// SUPER ADMIN
              sessiondata.i_idrole === 1 ||
                sessiondata.i_idrole === "1" ||
                // BELMAWA
                sessiondata.i_idrole === 10 ||
                sessiondata.i_idrole === "10" ||
                // REVIEWER
                sessiondata.i_idrole === 2013 ||
                sessiondata.i_idrole === "2013"
                ? p6aprove
                : p6aprove}
          </>
        );
        pengaturan_6 = (
          <>
            <tr>
              <td style={{ fontSize: "12px" }}>
                Pengaturan terkait peningkatan standar dalam SPMI Institusi
              </td>
              {p6status}
              {p6buttonHistorical}
              {p6buttonInterface}
            </tr>
            {/* <tr>
              <td style={{ fontSize: "12px" }}>
                tata cara pendokumentasian implementasi SPMI
              </td>
              {p6status}
              {p6buttonHistorical}
              {p6buttonInterface}
            </tr> */}
          </>
        );
      } else if (get_pengaturan.t6.status === 0) {
        p6status = (
          <>
            <td style={{ fontSize: "12px" }}>
              <span>
                <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                  <input
                    type="radio"
                    checked={p6_status === 1}
                    name="peningkatan"
                    value="ada"
                    onChange={this.handleEditButtonP6}
                  />
                  &nbsp; Ada
                </label>
              </span>
              &nbsp;&nbsp;
              <span>
                <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                  <input
                    checked
                    type="radio"
                    name="peningkatan"
                    value="tidakada"
                    onChange={this.handleEditButtonP6}
                  />
                  &nbsp; Tidak ada
                </label>
              </span>
            </td>
            {p6keterangan}
            {p6tanggal}
            {p6tahun}
            {p6verify}
          </>
        );
        pengaturan_6 = (
          <>
            <tr>
              <td style={{ fontSize: "12px" }}>
                Pengaturan terkait peningkatan standar dalam SPMI Institusi
              </td>
              {p6status}
              {p6buttonHistorical}
              {p6buttonInterface}
            </tr>
          </>
        );
      }
    } else {
      pengaturan_6 = (
        <>
          <tr>
            <td style={{ fontSize: "12px" }}>
              Pengaturan terkait peningkatan standar dalam SPMI Institusi
            </td>
            {sessiondata.i_idrole === 3 || sessiondata.i_idrole === "3" ? (
              <td style={{ fontSize: "12px" }}>
                <span>
                  <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                    <input
                      type="radio"
                      checked={p6_status === 1}
                      name="peningkatan"
                      value="ada"
                      onChange={this.handleShowP6}
                    />
                    &nbsp; Ada
                  </label>
                </span>
                &nbsp;&nbsp;
                <span>
                  <label style={{ paddingTop: "8px", marginBottom: "0px" }}>
                    <input
                      checked={p6_status === 0}
                      type="radio"
                      name="peningkatan"
                      value="tidakada"
                      onChange={this.handleShowP6}
                    />
                    &nbsp; Tidak ada
                  </label>
                </span>
              </td>
            ) : (
              <td style={{ textAlign: "center", fontSize: "12px" }}>-</td>
            )}

            <td colspan="5" style={{ fontSize: "12px" }}>
              Perguruan Tinggi wajib mengisi terkait Ada / Tidak ada Pengaturan
              Kebijakan SPMI
            </td>
          </tr>
        </>
      );
    }
    let bodyTable = "";
    let btnAksi = (
      <th
        style={{
          textAlign: "center",
          fontSize: "12px",
          textTransform: "uppercase",
          verticalAlign: "top",
          width: "230px",
        }}
      >
        Aksi
      </th>
    );

    if (this.state.loadingBar === true) {
      bodyTable = (
        <tr>
          <td colSpan="8">
            <LinearProgress color="secondary" variant="query" />
          </td>
        </tr>
      );
    } else {
      bodyTable = (
        <>
          {pengaturan_1}
          {pengaturan_2}
          {/* {pengaturan_3}
          {pengaturan_4}
          {pengaturan_5}
          {pengaturan_6} */}
        </>
      );
    }
    // console.log("trueFalse = ", this.state.showTidakAdaEdit);
    return (
      <>
        <Table responsive style={{ overflow: "auto" }}>
          <thead className="text-white" style={{ backgroundColor: "#3047ad" }}>
            <tr>
              <th
                style={{
                  fontSize: "12px",
                  textTransform: "uppercase",
                  verticalAlign: "top",
                }}
              >
                Nama Pengaturan
              </th>
              <th
                style={{
                  textAlign: "center",
                  fontSize: "12px",
                  textTransform: "uppercase",
                  verticalAlign: "top",
                }}
              >
                Status Pengaturan
              </th>
              <th
                style={{
                  textAlign: "center",
                  fontSize: "12px",
                  textTransform: "uppercase",
                  verticalAlign: "top",
                }}
              >
                Tautan
              </th>
              <th
                style={{
                  textAlign: "center",
                  fontSize: "12px",
                  textTransform: "uppercase",
                  verticalAlign: "top",
                }}
              >
                Tanggal ditetapkan
              </th>
              <th
                style={{
                  textAlign: "center",
                  fontSize: "12px",
                  textTransform: "uppercase",
                  verticalAlign: "top",
                }}
              >
                Tahun
              </th>
              <th
                style={{
                  textAlign: "center",
                  fontSize: "12px",
                  textTransform: "uppercase",
                  verticalAlign: "top",
                }}
              >
                Status Verifikasi
              </th>
              <th
                style={{
                  textAlign: "center",
                  fontSize: "12px",
                  textTransform: "uppercase",
                  verticalAlign: "top",
                }}
              >
                Status Dokumen
              </th>
              {btnAksi}
            </tr>
          </thead>
          <tbody>{bodyTable}</tbody>
        </Table>
        {/* Modals */}
        {/* Modals Dokumen Terkait ada pengaturan*/}
        <Modal size="lg" show={showAda} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Pengaturan Kebijakan SPMI Institusi</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Label htmlFor="input-with-icon-adornment">
                Deskripsi <small>*jika ada</small>{" "}
              </Form.Label>
              <Form.Control
                size="lg"
                type="text"
                as="textarea"
                placeholder="Deskripsi"
                value={deskripsi}
                onChange={(e) => this.onInputChangePengaturan(e, "deskripsi")}
              />
              <br />
              {/* <Form.Label htmlFor="input-with-icon-adornment">Keterangan </Form.Label>
                
                <Form.Control size="lg" type="text" placeholder="Keterangan terkait pengaturan" value={keterangan} onChange={(e) => this.onInputChangePengaturan(e, 'keterangan')} /><br /> */}
              <Form.Label htmlFor="input-with-icon-adornment">
                Tanggal Penetapan{" "}
              </Form.Label>
              <Form.Control
                size="lg"
                type="date"
                value={tanggal_penetapan}
                onChange={(e) =>
                  this.onInputChangePengaturan(e, "tanggal_penetapan")
                }
              />
              <Form.Control
                size="lg"
                type="hidden"
                value={id_jenis_aturan}
                onChange={(e) =>
                  this.onInputChangePengaturan(e, "id_jenis_aturan")
                }
              />
              <Form.Control
                size="lg"
                type="hidden"
                value={status}
                onChange={(e) => this.onInputChangePengaturan(e, "status")}
              />
              <Form.Control
                size="lg"
                type="hidden"
                value={id_sp}
                onChange={(e) => this.onInputChangePengaturan(e, "id_sp")}
              />
              <br />
              <Form.Label htmlFor="input-with-icon-adornment">
                Tautan terkait{" "}
              </Form.Label>
              <Form.Control
                size="lg"
                type="text"
                placeholder="http:// ..."
                value={tautan}
                onChange={(e) => this.onInputChangePengaturan(e, "tautan")}
              />
              <div
                style={{
                  textAlign: "center",
                  padding: "10px",
                  marginTop: "15px",
                  marginRight: "20px",
                  marginLeft: "20px",
                }}
              >
                <Alert variant="warning">
                  <b>
                    *Catatan: Pastikan link/tautan yang diberikan dapat
                    diakses/dibaca oleh publik!
                  </b>
                  <br />
                  (General Access : Anyone With The Link)
                </Alert>
              </div>
              <br />

              <span style={{ color: "red" }}>{this.state.errorMessage}</span>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <div style={{ textAlign: "right" }}>
              <Button
                disabled={loading}
                onClick={this.handleSavePengaturan}
                style={{
                  marginRight: "1vw",
                  backgroundColor: "#2061e3",
                  color: "white",
                }}
                variant="primary"
              >
                SIMPAN
                {loading && <i className="ml-3 spinner spinner-white"></i>}
                &nbsp;&nbsp;
              </Button>
            </div>
            <Button variant="secondary" onClick={this.handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        {/* Modals Dokumen EDIT Terkait ada pengaturan*/}
        <Modal size="lg" show={this.state.showEdit} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Pengaturan Kebijakan SPMI Institusi</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Label htmlFor="input-with-icon-adornment">
                Deskripsi <small>*jika ada</small>{" "}
              </Form.Label>
              <Form.Control
                size="lg"
                type="text"
                as="textarea"
                placeholder="Deskripsi"
                value={
                  this.state.deskrispiEdit !== "null"
                    ? this.state.deskrispiEdit
                    : "-"
                }
                onChange={(e) =>
                  this.onInputChangePengaturan(e, "deskrispiEdit")
                }
              />
              <br />
              <Form.Label htmlFor="input-with-icon-adornment">
                Tanggal Penetapan{" "}
              </Form.Label>
              <Form.Control
                size="lg"
                type="date"
                value={this.state.tanggal_penetapanEdit}
                onChange={(e) =>
                  this.onInputChangePengaturan(e, "tanggal_penetapanEdit")
                }
              />
              <br />
              <Form.Label htmlFor="input-with-icon-adornment">
                Tautan terkait{" "}
              </Form.Label>
              <Form.Control
                size="lg"
                type="text"
                placeholder="http:// ..."
                value={this.state.tautanEdit}
                onChange={(e) => this.onInputChangePengaturan(e, "tautanEdit")}
              />
              <div
                style={{
                  textAlign: "center",
                  padding: "10px",
                  marginTop: "15px",
                  marginRight: "20px",
                  marginLeft: "20px",
                }}
              >
                <Alert variant="warning">
                  <b>
                    *Catatan: Pastikan link/tautan yang diberikan dapat
                    diakses/dibaca oleh publik!
                  </b>
                  <br />
                  (General Access : Anyone With The Link)
                </Alert>
              </div>
              <br />

              <span style={{ color: "red" }}>{this.state.errorMessage}</span>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <div style={{ textAlign: "right" }}>
              <Button
                disabled={loading}
                onClick={this.handleSavePengaturanEdit}
                style={{
                  marginRight: "1vw",
                  backgroundColor: "#2061e3",
                  color: "white",
                }}
                variant="primary"
              >
                SIMPAN
                {loading && <i className="ml-3 spinner spinner-white"></i>}
                &nbsp;&nbsp;
              </Button>
            </div>
            <Button variant="secondary" onClick={this.handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        {/* Modals Alasan terkait tidak ada pengaturan*/}
        <Modal
          size="lg"
          show={this.state.showTidakAda}
          onHide={this.handleClose}
        >
          <Modal.Header closeButton>
            <Modal.Title>Berikan Alasan Tidak Ada</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Label>
              <label>
                <input
                  type="radio"
                  name="keterangan"
                  value="Belum ada pengaturan"
                  onChange={(e) =>
                    this.onInputChangePengaturan(e, "keterangan")
                  }
                />{" "}
                Belum ada pengaturan
              </label>
              <br />
              <label>
                <input
                  type="radio"
                  name="keterangan"
                  value="Masih dalam proses"
                  onChange={(e) =>
                    this.onInputChangePengaturan(e, "keterangan")
                  }
                />{" "}
                Masih dalam proses
              </label>
              <br />
              <label>
                <input
                  type="radio"
                  name="keterangan"
                  value="lainnya"
                  onChange={this.handleChangeAlasan}
                />{" "}
                Lainnya ...
              </label>
            </Form.Label>
            <hr />
            <Form.Group as={Row}>
              <br />
              <br />
              {isRadioSelected ? (
                <Form.Control
                  size="lg"
                  type="hidden"
                  name="keterangan"
                  placeholder="Disabled"
                  value={keterangan}
                  disabled={isRadioSelected}
                  onChange={(e) =>
                    this.onInputChangePengaturan(e, "keterangan")
                  }
                />
              ) : (
                <Form.Control
                  size="lg"
                  type="text"
                  name="keterangan"
                  placeholder="Isikan alasan tidak ada"
                  enabled={isRadioSelected}
                  value={keterangan}
                  onChange={(e) =>
                    this.onInputChangePengaturan(e, "keterangan")
                  }
                />
              )}
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <div style={{ textAlign: "right" }}>
              <Button
                disabled={loading}
                onClick={this.handleSavePengaturan}
                style={{
                  marginRight: "1vw",
                  backgroundColor: "#2061e3",
                  color: "white",
                }}
                variant="primary"
              >
                SIMPAN
                {loading && <i className="ml-3 spinner spinner-white"></i>}
                &nbsp;&nbsp;
              </Button>
            </div>
            <Button variant="secondary" onClick={this.handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        {/* Modals Alasan EDIT terkait tidak ada pengaturan*/}
        <Modal size="lg" show={showTidakAdaEdit} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Berikan Alasan Tidak Ada [EDIT]</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Label>
              <label>
                <input
                  type="radio"
                  name="keterangan"
                  value="Belum ada pengaturan"
                  onChange={(e) =>
                    this.onInputChangePengaturan(e, "keteranganEdit")
                  }
                />{" "}
                Belum ada pengaturan
              </label>
              <br />
              <label>
                <input
                  type="radio"
                  name="keterangan"
                  value="Masih dalam proses"
                  onChange={(e) =>
                    this.onInputChangePengaturan(e, "keteranganEdit")
                  }
                />{" "}
                Masih dalam proses
              </label>
              <br />
              <label>
                <input
                  type="radio"
                  name="keterangan"
                  value="lainnya"
                  onChange={this.handleChangeAlasan}
                />{" "}
                Lainnya ...
              </label>
            </Form.Label>
            <hr />
            <Form.Group as={Row}>
              <br />
              <br />
              {isRadioSelected ? (
                <Form.Control
                  size="lg"
                  type="hidden"
                  name="keterangan"
                  placeholder="Disabled"
                  value={this.state.keteranganEdit}
                  disabled={isRadioSelected}
                  onChange={(e) =>
                    this.onInputChangePengaturan(e, "keteranganEdit")
                  }
                />
              ) : (
                <Form.Control
                  size="lg"
                  type="text"
                  name="keterangan"
                  placeholder="Isikan alasan tidak ada"
                  enabled={isRadioSelected}
                  value={this.state.keteranganEdit}
                  onChange={(e) =>
                    this.onInputChangePengaturan(e, "keteranganEdit")
                  }
                />
              )}
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <div style={{ textAlign: "right" }}>
              <Button
                disabled={loading}
                onClick={this.handleSavePengaturanEdit}
                style={{
                  marginRight: "1vw",
                  backgroundColor: "#2061e3",
                  color: "white",
                }}
                variant="primary"
              >
                SIMPAN
                {loading && <i className="ml-3 spinner spinner-white"></i>}
                &nbsp;&nbsp;
              </Button>
            </div>
            <Button variant="secondary" onClick={this.handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        {/* Modals Alasan EDIT terkait tidak ada pengaturan*/}
        <Modal size="lg" show={showHistorical} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>
              {this.state.get_jenis === 1
                ? "Kebijakan SPMI"
                : this.state.get_jenis === 2
                  ? "Pengaturan tentang integrasi implementasi SPMI pada Manajemen Perguruan Tinggi"
                  : this.state.get_jenis === 3
                    ? "Pengaturan terkait pelaksanaan standar dalam SPMI Institusi"
                    : this.state.get_jenis === 4
                      ? "Pengaturan terkait evaluasi pelaksanaan standar"
                      : this.state.get_jenis === 5
                        ? "Pengaturan terkait pengendalian pelaksanaan standar"
                        : this.state.get_jenis === 6
                          ? "Pengaturan terkait peningkatan standar dalam SPMI Institusi"
                          : "Riwayat Pengaturan Tentang Kebijakan SPMI"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Table responsive style={{ overflow: "auto" }}>
              <thead
                className="text-white"
                style={{ backgroundColor: "#3047ad" }}
              >
                <th style={{ textAlign: "center" }}>Status</th>
                <th style={{ textAlign: "center" }}>Tautan</th>
                <th style={{ textAlign: "center" }}>Status Verfikasi</th>
                <th style={{ textAlign: "center" }}>Tanggal Penetapan</th>
                <th style={{ textAlign: "center" }}>Catatan</th>
              </thead>
              <tbody>{display_historical}</tbody>
            </Table>
          </Modal.Body>
          <Modal.Footer>
            <div style={{ textAlign: "right" }}>
              {/* <Button disabled={loading} onClick={this.handleSavePengaturanEdit} style={{marginRight:"1vw", backgroundColor:'#2061e3', color:'white'}} 
                    variant="primary">
                    SIMPAN
                    {loading && <i className="ml-3 spinner spinner-white"></i>}&nbsp;&nbsp;
                  </Button> */}
            </div>
            <Button variant="secondary" onClick={this.handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}
export default KebijakanSPMI;
